<script>
import {
    ColumnsDirective, ColumnDirective
} from '@syncfusion/ej2-vue-grids/src/grid/columns.directive';
import {
    AggregatesDirective, AggregateDirective
} from '@syncfusion/ej2-vue-grids/src/grid/aggregates.directive';
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import { configStore } from "@common/configStore";
import { ddStore } from "@common/ddStore";
import { controlStore, createStoreIndex } from "@common/control/controlStore";
import { actionStore } from "@common/actionStore";

const controlComponent = defineAsyncComponent(() => import('@common/control/control.vue'));

const configEditorSettings = {};

let masterGridConfig = {
    cId: "masterGrid",
    cType: "masterGrid",
    cTitle: "Main Grid",
    cTemplate: `<div v-if="config && !ddLoading" class="master-grid" :id="ref + '_wrapper'">
                    <div class="vms-main-grid-parts">
                        <div class="leftcolumn">
                            <div v-if="!reloadingMenuLeft" v-for="(item, index) in menuLeft" :key="index">
                                <control :name="item.name" :items="leftMenuItems(item)"></control>
                            </div>
                        </div>
                        <div class="rightcolumn">
                            <div id="gridControls">
                                <div class="grid-show-all">
                                    <control v-if="gridControls['SHOWALL']" :name="'SHOWALL__' + psp" :label="gridControls['SHOWALL']"></control>
                                </div>
                                <div class="grid-settings">
                                    <control v-if="gridControls['GRID_SET']" :name="'GRID_SET__' + psp" :label="gridControls['GRID_SET']"></control>
                                </div>
                                <div class="grid-sg-list">
                                    <control v-if="gridControls['GRID_SAVED_LIST']" :name="'GRID_SAVED_LIST__' + psp" :placeholder="gridControls['GRID_SAVED_LIST']"
                                    :items="grids"
                                    :value="selectedGrid"
                                    @update:value="selectedGrid = $event"
                                    ></control>
                                </div>
                                <div class="grid-filters">
                                    <control v-if="gridControls['FILTER-ACTION']" :name="'GRID_SEARCH__' + psp" :label="gridControls['FILTER-ACTION']"></control>
                                </div>
                                <div class="grid-filter-list">
                                    <control
                                        v-if="gridControls['FILTER_LIST']"
                                        :name="'GRID_FILTERS_LIST__' + psp"
                                        :placeholder="gridControls['FILTER_LIST']"
                                        :items="filters"
                                        :value="selectedFilter"
                                        @update:value="selectedFilter = $event"
                                    ></control>
                                </div>
                                <textarea :id="'clipboard__' + psp" class="master-grid-clipboard" :ref="'clipboard__' + psp" :value="clipboardValue"></textarea>
                            </div>
                            <div class="clearfix"></div>
                            <div v-if="psp === 14" id="professionsButtons"></div>
                            <div class="clearfix"></div>
                            <div>
                                <div v-if="gridControls['GRID_TYPE']" class="grid-navigator grid-type">
                                    <control
                                        :name="'GRID_TYPE__' + psp"
                                        :items="gridTypes"
                                        :value="selectedGridType"
                                        @update:value="selectedGridType = $event"
                                    ></control>
                                </div>
                                <div class="grid-navigator e-pagertemplatemessage">
                                    {{totalRecordsCount > 0 ? ((currentPage - 1) * pageSize + 1) : 0}} to {{currentPage * pageSize > totalRecordsCount ? totalRecordsCount : currentPage * pageSize}} of {{totalRecordsCount}} {{itemsTitle}}
                                    <span v-for="(count, tmpPsp) in rowCountAdditional">
                                        | {{count}} of total {{count}} {{itemsTitle}}
                                    </span>
                                </div>
                                <div v-if="!hidePager" class="grid-navigator control-section">
                                    <span>
                                        <span>Page {{currentPage}} of {{totalPages}}</span>
                                        <a class="grid-navigator-pages" href="javascript:void(0)" @click="goToPage(1)" style="cursor: default;">
                                            <img v-if="currentPage === 1" :src="projectUrl + '/coordinator/xsl/images/sArrowForwardLeftDisabled.gif'" alt="Go to the first page">
                                            <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowForwardLeft.gif'" alt="Go to the first page">
                                        </a>
                                        <a class="grid-navigator-pages" href="javascript:void(0)" @click="goToPage(currentPage - 1)" style="cursor: default;">
                                            <img v-if="currentPage === 1" :src="projectUrl + '/coordinator/xsl/images/sArrowLeftDisabled.gif'" alt="Go to previous page">
                                            <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowLeft.gif'" alt="Go to previous page">
                                        </a>
                                        <input :ref="'pageInput'" type="text" size="3" aria-label="page number" maxlength="10" class="grid-navigator-pages gridEngineNavigator" @keyup.enter="goToPage" :value="currentPage">
                                        <a class="grid-navigator-pages" href="javascript:void(0)" @click="goToPage(currentPage + 1)" style="cursor: pointer;">
                                            <img v-if="currentPage === totalPages" :src="projectUrl + '/coordinator/xsl/images/sArrowRightDisabled.gif'" alt="Go to next page">
                                            <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowRight.gif'" alt="Go to next page">
                                        </a>
                                        <a class="grid-navigator-pages" href="javascript:void(0)" @click="goToPage(totalPages)" style="cursor: pointer;">
                                            <img v-if="currentPage === totalPages" :src="projectUrl + '/coordinator/xsl/images/sArrowForwardRightDisabled.gif'" alt="Go to the last page">
                                            <img v-else :src="projectUrl + '/coordinator/xsl/images/sArrowForwardRight.gif'" alt="Go to the last page">
                                        </a>
                                    </span>
                                </div>
                                <div v-if="gridControls['CLIENT_GRID_DETAILS_BY']" class="grid-navigator grid-details-by">
                                    <control
                                        :name="'CLIENT_GRID_DETAILS_BY__' + psp"
                                        :items="gridModes"
                                        :value="selectedGridMode"
                                        @update:value="selectedGridMode = $event"
                                    ></control>
                                </div>
                                <div v-if="entitiesSummary" class="grid-navigator entities-summary">
                                    <span class="entities-summary-toggler" @click="toggleEntitiesSummary">{{showEntitiesSummary ? '[-]' : '[+]'}}</span>
                                    <span v-if="showEntitiesSummary">&nbsp;{{entitiesSummary}}</span>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div :class="{'grid-wrapper': true}" v-if="!preparingData" style="display: grid;">
                                <ejs-tooltip ref="gridHeaderCellTooltip" :beforeRender="beforeHeaderCellTooltipRender" target=".e-headertext">
                                <ejs-tooltip ref="gridCellTooltip" target=".e-rowcell" :beforeRender="beforeTooltipRender">
                                    <ejs-grid :id="cId"
                                              :dataSource="records"
                                              :dataBound="dataBound"
                                              :height="vueGridSettings.height || height"
                                              :rowHeight="vueGridSettings.rowHeight || 36"
                                              :width="width || 'auto'"
                                              :allowPaging="vueGridSettings.paging"
                                              :allowSorting="vueGridSettings.sorting"
                                              :sortSettings="vueGridSettings.sortSettings"
                                              :allowGrouping="vueGridSettings.grouping"
                                              :groupSettings='vueGridSettings.groupSettings'
                                              :allowMultiSorting="true"
                                              :allowFiltering="vueGridSettings.filtering"
                                              :allowResizing="vueGridSettings.resizing"
                                              :allowReordering="vueGridSettings.reordering"
                                              :toolbar="vueGridSettings.toolbar"
                                              :allowExcelExport="vueGridSettings.allowExcelExport"
                                              :rowSelected="rowSelected"
                                              :rowDeselected="rowSelected"
                                              :pageSettings="pageSettings"
                                              :clipMode="'Ellipsis'"
                                              :contextMenuItems="ctxMenu"
                                              :contextMenuOpen="contextMenuOpen"
                                              :contextMenuClick="contextMenuClick"
                                              :recordDoubleClick="recordDoubleClick"
                                              :actionBegin="actionBegin"
                                              :resizeStart="resizeStart"
                                              :resizeStop="resizeStop"
                                              :columnDragStart="columnDragStart"
                                              :columnDrop="columnDrop"
                                              :allowSelection="true"
                                              :childGrid="vueGridSettings.childGrid"
                                              :toolbarTemplate="vueGridSettings.toolbarTemplate"
                                              :ref="ref">
                                        <e-columns>
                                            <e-column v-for="(item, key) in headers"
                                                      :key="key" :field="item.field"
                                                      :customAttributes="item.customAttributes || {}"
                                                      :headerText="item.text"
                                                      :width="item.width"
                                                      :minWidth="item.minWidth"
                                                      :maxWidth="item.maxWidth"
                                                      :type="item.type || null"
                                                      :format="item.format || null"
                                                      :showInColumnChooser="typeof item.showInColumnChooser !== 'undefined' ? item.showInColumnChooser : true"
                                                      :visible="typeof item.visible !== 'undefined' ? item.visible : true"
                                                      :allowSorting="item.allowSorting === false ? false : (item.isSortable === 0 ? false : true)"
                                                      :allowFiltering="item.isSortable === 0 ? false : true"
                                                      :allowGrouping="item.isSortable === 0 ? false : true"
                                                      :filterTemplate="filterTemplates && filterTemplates[item.field]"
                                                      :filter="item.filter || null"
                                                      :sortComparer='sortComparer'
                                                      :template="columnTemplates && columnTemplates[item.field]"></e-column>
                                        </e-columns>
                                        <e-aggregates v-if="vueGridSettings.grouping">
                                            <e-aggregate v-for="(item, key) in aggregates" :key="key">
                                                <e-columns>
                                                    <e-column
                                                        :field="item.field"
                                                        :type="'Custom'"
                                                        :customAggregate="item.customAggregateFn"
                                                        :groupCaptionTemplate="item.groupCaptionTemplate"></e-column>
                                                </e-columns>
                                            </e-aggregate>
                                        </e-aggregates>
                                    </ejs-grid>
                                </ejs-tooltip>
                                </ejs-tooltip>
                                <div v-if="gridSettings.SUMMARY_MODE" class="summaryGrid" :style="{ 'margin-top': this.summaryInfoMarginTop }">
                                    <div class="infoTitle"><span>Summary info</span></div>
                                    <div class="infoRow">
                                        <div v-for="(item, key) in headers" class="infoCol">
                                            <div :id="'summary_' + item.field" :style="{ 'min-width': (parseFloat(item.width) + (key === 0 && typeof this.groupingColumns === 'object' && Object.keys(this.groupingColumns).length !== 0 ? 20 : 0)) + 'px' }">
                                                {{key !== 0 ? (typeof this.data.summary !== 'undefined' && typeof this.data.summary[item.field] !== 'undefined' && this.data.summary[item.field]?.length === 2 ? this.data.summary[item.field][0] : 'N/A') : ''}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="infoTitle"><span>Average info</span></div>
                                    <div class="infoRow">
                                        <div v-for="(item, key) in headers" class="infoCol">
                                            <div :id="'avarage_' + item.field" :style="{ 'min-width': (parseFloat(item.width) + (key === 0 && typeof this.groupingColumns === 'object' && Object.keys(this.groupingColumns).length !== 0 ? 20 : 0)) + 'px' }">
                                                {{key !== 0 ? (typeof this.data.summary !== 'undefined' && typeof this.data.summary[item.field] !== 'undefined' && this.data.summary[item.field]?.length === 2 ? this.data.summary[item.field][1] : 'N/A') : ''}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="false">
                        <div v-if="!reloadingGroupCheckbox" v-for="(item, key) in recordsByGroups" :key="key">
                            <teleport :to='groupsTeleportTo[key]'>
                                <control :value="groupSelected[key]" @update:value="groupSelected[key] = $event;" :name="'GROUP_SELECT_ALL__' + key" :actionParams="key"></control>
                            </teleport>
                        </div>
                    </div>
                </div>`,
    controls: [
        {
            name: 'SHOWALL',
            type: 'button',
            label: 'Show All',
            onclick: 'doAction',
            additionalData: {
                type: 'showAll'
            }
        },
        {
            name: 'GRID_SET',
            type: 'button',
            label: 'Grid Settings',
            onclick: 'doAction',
            additionalData: {
                type: 'customizeGrid'
            }
        },
        {
            name: 'GRID_SEARCH',
            type: 'button',
            label: 'Filters',
            onclick: 'doAction',
            additionalData: {
                type: 'filter'
            }
        },
        {
            name: 'GRID_SAVED_LIST',
            type: 'dropdown',
            onchange: 'setGridSettings',
            noRecordsTemplate: 'No saved grids found',
            placeholder: 'Start typing a grid name...',
            allowFiltering: true,
            fields: { text: 'text', value: 'value' }
        },
        {
            name: 'GRID_FILTERS_LIST',
            type: 'dropdown',
            onchange: 'setGridSettings',
            noRecordsTemplate: 'No filters found',
            placeholder: 'Start typing a filter name...',
            allowFiltering: true,
            fields: { text: 'text', value: 'value' }
        },
        {
            name: 'GRID_TYPE',
            type: 'dropdown',
            onchange: 'setGridSettings',
            showClearButton: false,
            fields: { text: 'text', value: 'value' }
        },
        {
            name: 'CLIENT_GRID_DETAILS_BY',
            label: 'DD.DATA_GRID.CUSTOMIZEGRID_32_DETAILS_MODE',
            type: 'dropdown',
            inlineLabel: true,
            onchange: 'setGridSettings',
            showClearButton: true,
            fields: { text: 'text', value: 'value' }
        },
        {
            name: 'GROUP_SELECT_ALL',
            type: 'checkbox',
            onchange: 'subGroupSelect'
        }
    ]
};

const generateColumnTemplate = (template) => () => ({
    template: vueApp.component('gridColumnTemplate', {
        template: template,
        components: {
            control: controlComponent
        }
    }),
    data() {
        return { data: {} };
    }
});

let masterGridCmp = {
    editorSettings: configEditorSettings,
    name: 'masterGrid',
    preInitControls: true,
    props: {
        psp: {
            default: 1
        },
        selectedRecords: {
            default: []
        },
        selectedRecordsFullData: {
            default: []
        },
    },
    data() {
        return {
            records: false,
            summary: false,
            headers: false,
            aggregates: [],
            columnTemplates: {},
            filterTemplates: false,
            preparingData: true,
            reloadingGroupCheckbox: false,
            width: 'auto',
            height: false,
            oldHeight: false,
            summaryInfoMarginTop: '0px',
            filterValue: {},
            ctxMenu: [],
            gridControls: [],
            selectedGrid: null,
            selectedFilter: null,
            selectedGridType: null,
            selectedGridMode: null,
            currentPage: 1,
            totalPages: 0,
            pageSize: 100,
            hidePager: false,
            rowCountAdditional: {},
            totalRecordsCount: 0,
            menuLeft: [],
            filters: [],
            grids: [],
            gridTypes: [
                { text: 'Any Affiliation', value: -1 },
                { text: 'DD.COMMON.ENTITY_AFFILIATION_VOL_ORG', value: 0 },
                { text: 'DD.COMMON.ENTITY_AFFILIATION_VOL_ASSIGNMENT', value: 1 },
                { text: 'DD.COMMON.ENTITY_AFFILIATION_VOL_AE', value: 2 },
                { text: 'DD.COMMON.ENTITY_AFFILIATION_ORG_ORG', value: 3 },
                { text: 'DD.COMMON.ENTITY_AFFILIATION_VOL_OPP', value: 4 },
            ],
            gridModes: [
                { text: 'DD.DATA_GRID.CUSTOMIZEGRID_32_DET_BY_AFF_VOL', value: 'AFF_VOL' },
                { text: 'DD.DATA_GRID.CUSTOMIZEGRID_32_DET_BY_AFF_ORG', value: 'AFF_ORG' },
                { text: 'DD.DATA_GRID.CUSTOMIZEGRID_32_DET_BY_AFF_AE', value: 'AFF_AE' },
            ],
            clipboardValue: '',
            columnRemoved: false,
            groupingColumns: {},
            prevSelectedRecords: [],
            sortingColumns: [],
            groupsTeleportTo: {},
            recordsByGroups: {},
            groupSelected: {},
            reloadingMenuLeft: false,
            customCtxMenu: [
                { title: 'Edit Volunteer', action: 'AFFGRID_VOLUNTEER_EDIT' },
                { title: 'Edit Organization', action: 'AFFGRID_ORGANIZATION_EDIT' },
                { title: 'Edit Activity', action: 'AFFGRID_ACTIVITY_EDIT' },
                { title: 'Edit Affiliation', action: 'AFFGRID_EDIT' },
                { title: 'Copy to clipboard', action: 'clipboard' },
            ],
            vueGridSettings: {
                "paging": true,
                "sorting": true,
                "rowHeight": 28,
                "calculateWidth": true,
                "filtering": true,
                "grouping": true,
                "resizing": true,
                "reordering": true,
                "minHeight": '230',
                "enableCheckBox": true,
                "clipMode": "EllipsisWithTooltip",
                "heightToContent": true,
                "isMainGrid": true
            },
            entitiesSummary: '',
            showEntitiesSummary: false,
            gridSettings: {},
            data: {},
            ddLoading: true
        };
    },
    computed: {
        selectedByPsp() {
            let selectedByPsp = {
                'vol': [],
                'opp': [],
                'org': [],
                'mem': [],
                'aff': [],
                'ae': [],
            };
            this.selectedRecordsFullData.forEach((selectedItem) => {
                for (let i in selectedByPsp) {
                    if (this.currentPspAbbrev === i) {
                        selectedByPsp[i].push(parseInt(selectedItem['rowID'], 10));
                        selectedByPsp[i] = library.uniqueArray(selectedByPsp[i]);
                    } else if (parseInt(selectedItem[i + 'ID'], 10) > 0) {
                        selectedByPsp[i].push(parseInt(selectedItem[i + 'ID'], 10));
                        selectedByPsp[i] = library.uniqueArray(selectedByPsp[i]);
                    }
                }
            });
            return selectedByPsp;
        },
        currentPspAbbrev() {
            return configStore.pspParentNamesAbbrev[this.psp];
        },
        projectUrl() {
            return typeof PROJECTS_URL !== 'undefined' ? PROJECTS_URL : '/';
        },
        ref() {
            return this.cId;
        },
        itemsTitle() {
            return configStore.pspParentNamesPlural[this.psp];
        },
        pageSettings() {
            return {
                "pageSize": this.pageSize
            };
        }
    },
    methods: {
        leftMenuItems(button) {
            let tmpItems = [];
            if (button?.additionalData?.items?.length) {
                for (let i in button.additionalData.items) {
                    if (i === 'length') continue;
                    let tmpItem = library.cloneObj(button.additionalData.items[i]);
                    if (tmpItem.needSelected) {
                        let recordPsp = tmpItem.needSelectedPsp || 'aff';
                        if (!recordPsp || typeof this.selectedByPsp === 'undefined' || !this.selectedByPsp[recordPsp]?.length) {
                            continue;
                        }
                    }
                    tmpItem.text = tmpItem.title;
                    tmpItem.additionalData = { action: button.additionalData.items[i].action };
                    tmpItems.push(tmpItem);
                }
            }
            return tmpItems;
        },
        disableMenuLeftControls() {
            this.menuLeft.forEach((button) => {
                if (this.controls[button.name]) {
                    this.controls[button.name].disabled = this.isMenuItemDisabled(button.name, true);
                }
            });
        },
        isMenuItemDisabled(name, checkBySelected, forceSelected) {
            if (!this.controls[name]) return false;
            let selectedCount = this.selectedRecordsFullData.length || 0;
            let disable = false;
            if (this.controls[name].additionalData) {
                disable = (checkBySelected && !selectedCount && this.controls[name].additionalData.needSelected) // need selected at least one
                    || (checkBySelected && selectedCount !== 1 && this.controls[name].additionalData.needOneSelected) // need selected only one
                    || (
                        !forceSelected
                        && (this.controls[name].additionalData.needSelected || this.controls[name].additionalData.needOneSelected)
                        && this.controls[name].additionalData.needSelectedPsp
                        && !this.selectedByPsp[this.controls[name].additionalData.needSelectedPsp].length
                    ); // need other psp id
            }
            if (!disable) disable = false;
            return disable;
        },
        beforeHeaderCellTooltipRender(args) {
            if (args?.target?.classList?.contains('e-headertext') && args.target.innerText && Array.isArray(this.headers)) {
                let tmpHeader = this.headers.find((tmp) => tmp.text === args.target.innerText);
                if (tmpHeader) {
                    let tmpTooltip = '';
                    if (tmpHeader.drawTitleProfile) tmpTooltip += 'Profile: ' + tmpHeader.drawTitleProfile + '<br/>';
                    if (tmpHeader.drawTitleGroup) tmpTooltip += 'Group: ' + tmpHeader.drawTitleGroup + '<br/>';
                    if (tmpHeader.drawTitleField) tmpTooltip += 'Field: ' + tmpHeader.drawTitleField.replace(/^vol:|opp:|org:|aff:|ae:/gi, '') + '<br/>';
                    this.$refs.gridHeaderCellTooltip.ej2Instances.content = tmpTooltip;
                    this.$refs.gridHeaderCellTooltip.ej2Instances.windowCollision = true;
                    this.$refs.gridHeaderCellTooltip.ej2Instances.cssClass = 'gridHeaderCellTooltip';
                    if (args?.event?.clientX > window.innerWidth - 150) {
                        this.$refs.gridHeaderCellTooltip.ej2Instances.position = 'TopLeft';
                    } else {
                        this.$refs.gridHeaderCellTooltip.ej2Instances.position = 'TopCenter';
                    }
                } else {
                    args.cancel = true;
                }
            } else {
                args.cancel = true;
            }
        },
        beforeTooltipRender(args) {
            if (args?.target?.classList?.contains('e-rowcell') && args.target.innerText) {
                let elWithRealWidth = args.target.querySelectorAll('.cell-real-width')[0];
                if (elWithRealWidth && elWithRealWidth.offsetWidth > args.target.clientWidth) {
                    this.$refs['gridCellTooltip'].ej2Instances.content = args.target.innerHTML.replaceAll('\n', '<br/>');
                } else {
                    args.cancel = true;
                }
            } else {
                args.cancel = true;
            }
        },
        sortComparer() {
            return 0;
        },
        renderHeaderGroup() {
            if (typeof this.$refs?.[this.ref]?.$el?.querySelectorAll === 'function') {
                let groupArea = this.$refs[this.ref].$el.querySelectorAll('.e-groupdroparea');
                let gridHeader = this.$refs[this.ref].$el.querySelectorAll('.e-gridheader .e-headercontent');
                if (typeof groupArea?.[0]?.style !== 'undefined'
                    && typeof gridHeader?.[0]?.style !== 'undefined'
                ) {
                    let groupAreaStyles = getComputedStyle(groupArea[0]);
                    let gridHeaderStyles = getComputedStyle(gridHeader[0]);
                    if (groupAreaStyles && gridHeaderStyles && groupAreaStyles.width !== gridHeaderStyles.width) {
                        groupArea[0].style.width = gridHeaderStyles.width;
                    }
                }

                let headerGroupCells = this.$refs[this.ref].$el.querySelectorAll('.e-columnheader .e-grouptopleftcell');
                let alreadyAdded = this.$refs[this.ref].$el.querySelectorAll('.e-columnheader .group-collapse-all');
                if (typeof headerGroupCells?.[0]?.append === 'function' && !alreadyAdded.length) {
                    headerGroupCells[0].classList.add('e-grouptopleftcell-group-ungroup-all');
                    headerGroupCells[0].classList.add('expanded');
                    let collapseLink = document.createElement('a');
                    collapseLink.onclick = () => {
                        headerGroupCells[0].classList.remove('expanded');
                        headerGroupCells[0].classList.add('collapsed');
                        this.$refs[this.ref].groupCollapseAll();
                    };
                    collapseLink.title = "Expanded";
                    collapseLink.href = '#';
                    collapseLink.className = 'e-icons e-gdiagonaldown e-icon-gdownarrow group-collapse-all';
                    headerGroupCells[0].append(collapseLink);

                    let expandLink = document.createElement('a');
                    expandLink.onclick = () => {
                        headerGroupCells[0].classList.remove('collapsed');
                        headerGroupCells[0].classList.add('expanded');
                        this.$refs[this.ref].groupExpandAll();
                    };
                    expandLink.title = "Collapsed";
                    expandLink.href = '#';
                    expandLink.className = 'e-icons e-gnextforward e-icon-grightarrow group-expand-all';

                    headerGroupCells[0].append(expandLink);
                }
            }
        },
        getRecordsByGroups() {
            if (this.reloadingData) return;
            this.reloadingGroupCheckbox = true;
            this.groupsTeleportTo = {};
            this.recordsByGroups = {};
            this.groupSelected = {};
            if (this?.vueGridSettings?.grouping && typeof this?.$refs?.[this.ref]?.ej2Instances?.getRowsObject === 'function') {
                let rowsObject = this.$refs[this.ref].ej2Instances.getRowsObject();
                let groups = {};
                let groupsTeleportTo = {};
                let currentNested = [];
                let prevIsData = false;
                let groupId = 0;
                rowsObject.forEach((record, i) => {
                    if (!record.isDataRow) {
                        if (prevIsData) {
                            if (record.indent >= 0) {
                                while (currentNested.length !== record.indent) {
                                    currentNested.pop();
                                }
                            }
                            prevIsData = false;
                        }
                        currentNested.push(record.data.key);
                        let currentGroupKey = currentNested.join('__,__');
                        groupsTeleportTo[currentGroupKey] = '#masterGridcaptioncell' + groupId + ' .group-checkbox';
                        groupId++;
                    } else {
                        prevIsData = true;
                        for (let tmpI in currentNested) {
                            let currentGroupKey = currentNested.slice(0, (parseInt(tmpI, 10) + 1)).join('__,__');
                            if (!Array.isArray(groups[currentGroupKey])) groups[currentGroupKey] = [];
                            groups[currentGroupKey].push(record.index);
                        }
                    }
                });
                this.groupsTeleportTo = library.cloneObj(groupsTeleportTo);
                this.recordsByGroups = library.cloneObj(groups);
            }
            this.$nextTick(() => {
                if (!this.reloadingData) {
                    this.reloadingGroupCheckbox = false;
                }
            });
        },
        subGroupSelect(ev, el, groupKey) {
            if (
                Array.isArray(this.recordsByGroups[groupKey])
                && this.recordsByGroups[groupKey].length
                && typeof this?.$refs?.[this.ref]?.ej2Instances?.getSelectedRowIndexes === 'function'
            ) {
                let prevSelected = library.cloneObj(this.$refs[this.ref].ej2Instances.getSelectedRowIndexes());
                this.$refs[this.ref].ej2Instances.clearRowSelection();
                let selectRows = [];
                if (ev.checked) {
                    selectRows = [...prevSelected, ...this.recordsByGroups[groupKey]];
                } else {
                    selectRows = prevSelected.filter((tmp) => !this.recordsByGroups[groupKey].includes(tmp));
                }
                if (Array.isArray(selectRows) && selectRows.length) this.$refs[this.ref].ej2Instances.selectRows(selectRows);
            }
        },
        selectPrevious() {
            this.$nextTick(() => {
                let prevSelectedIndexes = [];
                let gridRecords = this.$refs[this.ref].ej2Instances.getRowsObject();
                if (this.prevSelectedRecords.length && gridRecords && gridRecords.length) {
                    gridRecords.forEach((record, i) => {
                        if (this.prevSelectedRecords.indexOf(record.data.ID) !== -1) {
                            prevSelectedIndexes.push(record.index);
                        }
                    });
                }
                if (prevSelectedIndexes.length && typeof this.$refs?.[this.ref]?.ej2Instances?.selectRows === 'function') {
                    this.$refs[this.ref].ej2Instances.selectRows(prevSelectedIndexes);
                }
            });
        },
        resizeHeight() {
            let minusHeight = this.psp === 14 ? 300 : 160; // NOSONAR
            let tmpHeight = this.$parent.$el.parentElement.clientHeight - minusHeight;
            if (typeof this?.$parent?.$el?.querySelectorAll !== 'undefined' && this.$parent.$el.querySelectorAll('.e-gridcontent').length) {
                tmpHeight = document.body.clientHeight - this.$parent.$el.querySelectorAll('.e-gridcontent')[0].getBoundingClientRect().top - 25; // NOSONAR
            }
            if (this.config && this.vueGridSettings.minHeight && tmpHeight < this.vueGridSettings.minHeight) {
                tmpHeight = this.vueGridSettings.minHeight;
            }

            this.height = tmpHeight;
            this.summaryInfoMarginTop = '0px';

            if (this.gridSettings.SUMMARY_MODE && this.$parent.$el.querySelector('.e-gridcontent .e-table')?.clientHeight) {
                if (!this.oldHeight && this.height && this.height > 500 && this.$parent.$el.querySelector('.summaryGrid')?.clientHeight) {
                    this.oldHeight = this.height;
                    this.height -= this.$parent.$el.querySelector('.summaryGrid')?.clientHeight;
                    tmpHeight = this.height;
                }

                let tableHeight = this.$parent.$el.querySelector('.e-gridcontent .e-table').clientHeight;

                if (tableHeight < tmpHeight) {
                    this.summaryInfoMarginTop = (tableHeight - tmpHeight + 10) + 'px';
                }
                let currentHeaders = this.$el.querySelectorAll('.e-headercell');
                let groupingHeaders = this.$el.querySelectorAll('.e-columnheader .e-grouptopleftcell');
                let addGroupingWidth = 0;
                for (let i in groupingHeaders) {
                    if (groupingHeaders[i].clientWidth) addGroupingWidth += groupingHeaders[i].clientWidth;
                }
                for (let i in this.headers) {
                    let tmpSumDiv = document.getElementById('summary_' + this.headers[i].field);
                    if (currentHeaders[i] && tmpSumDiv) {
                        tmpSumDiv.style.width = currentHeaders[i].getBoundingClientRect().width + (parseInt(i, 10) === 0 ? addGroupingWidth : 0) + 'px';
                    }
                    let tmpAvgDiv = document.getElementById('avarage_' + this.headers[i].field);
                    if (currentHeaders[i] && tmpAvgDiv) {
                        tmpAvgDiv.style.width = currentHeaders[i].getBoundingClientRect().width + (parseInt(i, 10) === 0 ? addGroupingWidth : 0) + 'px';
                    }
                }
            } else if (this.oldHeight && this.height) {
                this.height = this.oldHeight;
                this.oldHeight = false;
            }
        },
        dataBound() {
            this.renderHeaderGroup();
            this.selectPrevious();
            this.getRecordsByGroups();
            this.resizeHeight();
            this.$emit('update:dataBound', true);
        },
        async onLoad() {
            window.addEventListener('resize', this.resizeHeight, true);
            this.resizeHeight();
            this.ddLoading = true;
            await ddStore.preloadGroup('COMMON');
            await ddStore.preloadGroup('DATA_GRID');
            this.ddLoading = false;
            this.findButtonLabel = await ddStore.getAlias('COMMON', 'BUTTON_FIND');
            let abbrev = configStore.pspParentNamesAbbrev[this.psp];
            if (abbrev) {
                configStore.getEcUserProperty(abbrev.toUpperCase() + '_showEntitiesSummary').then((response) => {
                    this.showEntitiesSummary = !!response;
                });
            }
            this.reloadGrid();
        },
        prepareData() {
            this.preparingData = true;
            this.$emit('update:preparingData', true);
            let tmpRecords;
            let tmpSummary;
            let tmpHeaders;
            let getHeadersFromSampleRecord = (iRecords, fromProp) => {
                let iHeaders = [];
                let width = this.vueGridSettings.width || 'auto';
                if (this.vueGridSettings.calculateWidth) {
                    width = 10;
                }
                let seachFunction = async (ev) => {
                    this.$nextTick(() => {
                        this.setGridSettings(false, false, { isSearch: true });
                    });
                };
                let tmpFilterTemplates = {};
                this.filterTemplates = {};
                if (this.vueGridSettings.grouping && this.vueGridSettings.calculateWidth) {
                    width += 100;
                }
                if (this.vueGridSettings.enableCheckBox) {
                    if (width === 'auto') width = 0;
                    let findButtonLabel = this.findButtonLabel || 'Find';
                    let tmpMaxWidth = findButtonLabel.length * 7 + 22; // NOSONAR
                    if (this.vueGridSettings.calculateWidth) {
                        width += tmpMaxWidth + 20; // NOSONAR
                    }
                    iHeaders.push({
                        field: 'SEARCH',
                        text: '',
                        maxWidth: tmpMaxWidth + 'px',
                        type: 'checkbox',
                        showInColumnChooser: false,
                        customAttributes: {
                            class: 'custom-search-column'
                        }
                    });
                    let tmpTemplateName = this.cId + "_filter__template" + library.getUniqueID();
                    let template = library.createTemplateComponent(tmpTemplateName,
                        {
                            template: `<div>
                                            <control :name="'SEARCH__' + tmpTemplateName" :prop-config="{...controlConfig, ...{onclick: click}}"></control>
                                        </div>`,
                            components: {
                                control: controlComponent
                            },
                            data() {
                                return {
                                    data: {},
                                    tmpTemplateName: tmpTemplateName,
                                    controlName: 'SEARCH',
                                    controlConfig: {
                                        name: 'SEARCH',
                                        type: 'button',
                                        label: findButtonLabel
                                    },
                                    searchFunction: seachFunction
                                };
                            },
                            methods: {
                                click(ev) {
                                    seachFunction(ev);
                                }
                            }
                        }, this);
                    tmpFilterTemplates['SEARCH'] = template;
                }
                for (let i in iRecords) {
                    if (i === 'length') continue;
                    if (iRecords[i].width) {
                        if (width === 'auto') width = 0;
                        if (this.vueGridSettings.calculateWidth) {
                            width += iRecords[i].width;
                        }
                    }
                    if (!iRecords[i].columnTemplate) {
                        iRecords[i].columnTemplate = '<div><span class="cell-real-width" v-html="data[\'' + iRecords[i].GRID_FIELD_NAME + '\']"></span></div>';
                    }
                    if (iRecords[i].columnTemplate) {
                        if (!this.columnTemplates) this.columnTemplates = {};
                        let template = library.createTemplateComponent(this.cId + "_column_" + i + "_template",
                            {
                                template: '<div>' + iRecords[i].columnTemplate + '</div>',
                                components: {
                                    control: controlComponent
                                },
                                data() {
                                    return {
                                        data: {}
                                    };
                                },
                            }, this);
                        this.columnTemplates[iRecords[i].field] = template;
                    }
                    if (iRecords[i].filterTemplate) {
                        let controlType = 'string';
                        let controlInputType = 'string';
                        switch (iRecords[i].type) {
                            case 1:
                            case 2:
                            case 201:
                            case 16:
                                controlType = 'number';
                                controlInputType = 'number';
                                break;
                            case 5:
                            case 6:
                            case 9:
                            case 11:
                            case 203:
                                controlType = 'date';
                                controlInputType = 'string';
                                break;
                            case 13:
                            case 205:
                                controlType = 'dropdown';
                                controlInputType = 'dropdown';
                                break;
                        }
                        let changeFilter = (controlName, search, search1, option, text) => {
                            let filterValue = library.cloneObj(this.filterValue);
                            if (search instanceof Date) {
                                let day = search.getDate();
                                if (day < 10) day = '0' + day;
                                let month = search.getMonth() + 1;
                                if (month < 10) month = '0' + month;
                                let year = search.getFullYear();
                                search = month + '/' + day + '/' + year;
                            }
                            if (controlType === 'dropdown') {
                                option = text;
                            }
                            search = search || !isNaN(parseInt(search, 10)) ? search + '' : '';
                            search1 = search1 || !isNaN(parseInt(search1, 10)) ? search1 + '' : '';
                            filterValue[controlName] = {
                                CLIENT_GRID_SEARCH: search,
                                CLIENT_GRID_SEARCH_1: search1,
                                CLIENT_GRID_SEARCH_OPTION: parseInt(option, 10) || ""
                            };
                            this.filterValue = filterValue;
                        };
                        let controlItems = [];
                        if (iRecords[i].items) {
                            controlItems = iRecords[i].items;
                        }
                        let value = iRecords[i].CLIENT_GRID_SEARCH ? iRecords[i].CLIENT_GRID_SEARCH : "";
                        if (controlType === 'dropdown') {
                            for (let i in controlItems) {
                                if (i === 'length') continue;
                                if (controlItems[i].text === value) value = controlItems[i].value;
                            }
                        }
                        let secondValue = iRecords[i].CLIENT_GRID_SEARCH_1 ? iRecords[i].CLIENT_GRID_SEARCH_1 : "";
                        let ddValue = parseInt(iRecords[i].CLIENT_GRID_SEARCH_OPTION, 10) || 1;
                        this.filterValue[iRecords[i].field] = {
                            CLIENT_GRID_SEARCH: value,
                            CLIENT_GRID_SEARCH_1: secondValue,
                            CLIENT_GRID_SEARCH_OPTION: ddValue
                        };

                        let controlPlaceHolder = iRecords[i].placeholder || '';
                        let isShowEmptyDropdown = typeof iRecords[i].isShowEmptyDropdown === 'boolean' ? iRecords[i].isShowEmptyDropdown : false;

                        let templateName = this.cId + "_filter_" + i + "_template_" + library.getUniqueID();
                        let template = library.createTemplateComponent(templateName,
                            {
                                template: `
                                                    <div @click="click">
                                                        <div v-if="controlType === 'string' && !isShowEmptyDropdown">
                                                            <control :name="controlName + '_' + templateName" :prop-config="controlConfig" :value="value" :oninput="onchangeValue" :onchange="onchangeValue" ></control>
                                                        </div>
                                                        <div v-if="controlType === 'string' && isShowEmptyDropdown" class="string-empty-filter">
                                                            <control :name="controlName + '_stringEmptyDD_' + templateName" :prop-config="stringEmptyDD" :value="ddValue" :onchange="onchangeDD" ></control>
                                                            <control v-if="ddValue != -1 && ddValue != -2" :name="controlName + '_' + templateName" :prop-config="controlConfig" :value="value" :oninput="onchangeValue" :onchange="onchangeValue" ></control>
                                                        </div>
                                                        <div v-if="controlType === 'number'" class="number-filter">
                                                            <control :name="controlName + '_numberDD_' + templateName" :prop-config="numberDD" :value="ddValue" :onchange="onchangeDD" ></control>
                                                            <control :name="controlName + '_' + templateName" :prop-config="controlConfig" :value="value" :onchange="onchangeValue" ></control>
                                                            <control v-if="ddValue == 7" :name="controlName + '_numberSecond_' + templateName" :value="secondValue" :prop-config="numberSecond" :onchange="onchangeSecond" ></control>
                                                        </div>
                                                        <div v-if="controlType === 'date'" class="date-filter">
                                                            <control :name="controlName + '_dateDD_' + templateName" :prop-config="dateDD" :value="ddValue" :onchange="onchangeDD" ></control>
                                                            <control v-if="ddValue < 100 && datePeriodIsNumber.indexOf(ddValue) === -1" :name="controlName + '_' + templateName" :prop-config="controlConfig" :value="value" :onchange="onchangeValue" ></control>
                                                            <control v-if="datePeriodIsNumber.indexOf(ddValue) !== -1" :name="controlName + '_dateSecond_' + templateName" :prop-config="numberDate" :value="value" :onchange="onchangeValue" ></control>
                                                            <control v-if="ddValue == 9" :name="controlName + '_dateSecond_' + templateName" :prop-config="dateSecond" :value="secondValue" :onchange="onchangeSecond" ></control>
                                                        </div>
                                                        <div v-if="controlType === 'dropdown'">
                                                            <control :name="controlName + '_' + templateName" :prop-config="controlConfig" :onchange="onchangeValue" ></control>
                                                        </div>
                                                    </div>`,
                                components: {
                                    control: controlComponent
                                },
                                data() {
                                    return {
                                        templateName: templateName,
                                        data: {},
                                        controlName: iRecords[i].field,
                                        controlType: controlType,
                                        isShowEmptyDropdown: isShowEmptyDropdown,
                                        controlConfig: {
                                            name: iRecords[i].field,
                                            showSpinButton: false,
                                            type: controlInputType,
                                            value: value,
                                            fields: { text: 'text', value: 'value' },
                                            items: controlItems,
                                            placeholder: controlPlaceHolder
                                        },
                                        dateSecond: {
                                            type: 'string',
                                            value: secondValue
                                        },
                                        datePeriodIsNumber: [81, 82, 90, 91, 92, 93],
                                        dateDD: {
                                            type: 'dropdown',
                                            showClearButton: false,
                                            value: ddValue,
                                            popupWidth: 'auto',
                                            default: 1,
                                            fields: {
                                                text: 'text',
                                                value: 'value'
                                            },
                                            items: [
                                                {
                                                    text: '=',
                                                    value: 1
                                                },
                                                {
                                                    text: '>',
                                                    value: 5
                                                },
                                                {
                                                    text: '>=',
                                                    value: 6
                                                },
                                                {
                                                    text: '<',
                                                    value: 7
                                                },
                                                {
                                                    text: '<=',
                                                    value: 8
                                                },
                                                {
                                                    text: 'n-n',
                                                    value: 9
                                                },
                                                {
                                                    text: 'yesterday',
                                                    value: 101
                                                },
                                                {
                                                    text: 'today',
                                                    value: 102
                                                },
                                                {
                                                    text: 'today minus',
                                                    value: 90
                                                },
                                                {
                                                    text: 'today plus',
                                                    value: 91
                                                },
                                                {
                                                    text: 'today through minus',
                                                    value: 92
                                                },
                                                {
                                                    text: 'today through plus',
                                                    value: 93
                                                },
                                                {
                                                    text: 'today before minus',
                                                    value: 81
                                                },
                                                {
                                                    text: 'today after plus',
                                                    value: 82
                                                },
                                                {
                                                    text: 'tomorrow',
                                                    value: 103
                                                },
                                                {
                                                    text: 'last week',
                                                    value: 111
                                                },
                                                {
                                                    text: 'this week',
                                                    value: 112
                                                },
                                                {
                                                    text: 'next week',
                                                    value: 113
                                                },
                                                {
                                                    text: 'last month',
                                                    value: 121
                                                },
                                                {
                                                    text: 'this month',
                                                    value: 122
                                                },
                                                {
                                                    text: 'next month',
                                                    value: 123
                                                },
                                                {
                                                    text: 'last quarter',
                                                    value: 131
                                                },
                                                {
                                                    text: 'this quarter',
                                                    value: 132
                                                },
                                                {
                                                    text: 'next quarter',
                                                    value: 133
                                                },
                                                {
                                                    text: 'last year',
                                                    value: 141
                                                },
                                                {
                                                    text: 'this year',
                                                    value: 142
                                                },
                                                {
                                                    text: 'next year',
                                                    value: 143
                                                }
                                            ]
                                        },
                                        ddValue: ddValue,
                                        secondValue: secondValue,
                                        value: value,
                                        stringEmptyDD: {
                                            type: 'dropdown',
                                            value: ddValue,
                                            showClearButton: false,
                                            popupWidth: 'auto',
                                            default: 0,
                                            fields: {
                                                text: 'text',
                                                value: 'value'
                                            },
                                            items: [
                                                {
                                                    text: '',
                                                    value: 0
                                                },
                                                {
                                                    text: '*is empty',
                                                    value: -1
                                                },
                                                {
                                                    text: '*is not empty',
                                                    value: -2
                                                }
                                            ]
                                        },
                                        numberDD: {
                                            type: 'dropdown',
                                            value: ddValue,
                                            showClearButton: false,
                                            popupWidth: 'auto',
                                            default: 1,
                                            fields: {
                                                text: 'text',
                                                value: 'value'
                                            },
                                            items: [
                                                {
                                                    text: '=',
                                                    value: 1
                                                },
                                                {
                                                    text: '>',
                                                    value: 3
                                                },
                                                {
                                                    text: '>=',
                                                    value: 4
                                                },
                                                {
                                                    text: '<',
                                                    value: 5
                                                },
                                                {
                                                    text: '<=',
                                                    value: 6
                                                },
                                                {
                                                    text: 'n-n',
                                                    value: 7
                                                },
                                            ]
                                        },
                                        numberSecond: {
                                            type: 'number',
                                            showSpinButton: false,
                                            value: secondValue
                                        },
                                        numberDate: {
                                            type: 'number',
                                            showSpinButton: false,
                                            value: secondValue,
                                            min: 1
                                        }
                                    };
                                },
                                methods: {
                                    click(event) {
                                        event.stopPropagation();
                                    },
                                    onchange() {
                                        let value = this.value;
                                        let id = false;
                                        if (this.controlType === 'dropdown') {
                                            for (let i in this.controlConfig.items) {
                                                if (i === 'length') continue;
                                                if (this.controlConfig.items[i].value === this.value) {
                                                    value = this.controlConfig.items[i].text;
                                                    id = this.controlConfig.items[i].value;
                                                }
                                            }
                                        }
                                        changeFilter(this.controlName, value, this.secondValue, this.ddValue, id);
                                    },
                                    onchangeValue(event) {
                                        if (typeof event.value !== 'undefined') {
                                            this.value = event.value;
                                            this.onchange();
                                        }
                                    },
                                    onchangeSecond(event) {
                                        if (typeof event.value !== 'undefined') {
                                            this.secondValue = event.value;
                                            this.onchange();
                                        }
                                    },
                                    onchangeDD(event) {
                                        if (typeof event.value !== 'undefined') {
                                            this.ddValue = event.value;
                                            this.onchange();
                                        }
                                    }
                                }
                            }, this);
                        tmpFilterTemplates[iRecords[i].field] = template;
                    }
                    iHeaders.push(iRecords[i]);
                }
                this.filterTemplates = library.cloneObj(tmpFilterTemplates);
                this.width = width;
                return iHeaders;
            };
            if (this?.data?.records) {
                tmpRecords = [];
                if (typeof this.data?.records !== 'undefined' && Array.isArray(this.data.records)) {
                    this.data.records.forEach((tmpRecord) => {
                        if (!tmpRecord.CNT_COL) tmpRecords.push(tmpRecord);
                    });
                } else {
                    tmpRecords = library.cloneObj(this.data.records);
                }
                for (let i in tmpRecords) {
                    for (let j in tmpRecords[i]) {
                        if (typeof tmpRecords[i][j] === 'object' && !library.objIsEmpty(tmpRecords[i][j])) {
                            try {
                                tmpRecords[i][j] = Object.values(tmpRecords[i][j]).join(',\n');
                            } catch (e) {
                                // do nothing
                            }
                        }
                    }
                }
            }
            if (this?.data?.headers) {
                tmpHeaders = getHeadersFromSampleRecord(this.data.headers);
            }
            if (this?.data?.summary) {
                tmpSummary = [];
                for (let i in this.data.summary) {
                    if (i === 'length') continue;
                    let tmp = {};
                    tmp.data = library.cloneObj(this.data.summary[i]);
                    tmp.type = 'custom';
                    tmp.field = i;
                    tmpSummary.push(tmp);
                }
            }
            let grouping = false;
            let groupSettingsColumns = [];
            let sortSettingsColumns = [];
            this.sortingColumns = [];
            if (!Array.isArray(tmpHeaders)) tmpHeaders = [];
            let groupedColumns = tmpHeaders.filter((tmp) => tmp.isSortable && tmp.CLIENT_GRID_SORT_GROUP_BY);
            if (groupedColumns.length) grouping = true;
            for (let i in tmpHeaders) {
                if (i === 'length') continue;
                if (tmpHeaders[i].isSortable) {
                    if (tmpHeaders[i].CLIENT_GRID_SORT_GROUP_BY) {
                        grouping = true;
                        groupSettingsColumns[tmpHeaders[i].CLIENT_GRID_SORT_POS - 1] = tmpHeaders[i].field;
                        this.groupingColumns[tmpHeaders[i].field] = 1;
                    }
                    if (tmpHeaders[i].CLIENT_GRID_SORT_POS) {
                        sortSettingsColumns[tmpHeaders[i].CLIENT_GRID_SORT_POS - 1] = {
                            direction: tmpHeaders[i].CLIENT_GRID_SORT_DIR ? 'Descending' : 'Ascending', // @todo recheck
                            field: tmpHeaders[i].field
                        };
                        this.sortingColumns[tmpHeaders[i].CLIENT_GRID_SORT_POS - 1] = tmpHeaders[i].field;
                    }
                }
            }
            groupSettingsColumns = groupSettingsColumns.filter((tmpEl) => typeof tmpEl !== 'undefined');
            let captionTemplate = library.createTemplateComponent(this.cId + "_caption__template",
                {
                    template: `<div></div>`,
                    components: {
                        control: controlComponent
                    },
                    data() {
                        return {
                            data: {},
                        };
                    },
                }, this);
            this.vueGridSettings.groupSettings = {
                showGroupedColumn: true,
                showDropArea: true,
                columns: grouping ? groupSettingsColumns : [],
                captionTemplate: captionTemplate
            };
            if (sortSettingsColumns.length) {
                if (sortSettingsColumns.length === 1) {
                    sortSettingsColumns.push({
                        direction: "Ascending",
                        field: "SEARCH"
                    });
                }
                this.vueGridSettings.sortSettings = { allowUnsort: false, columns: sortSettingsColumns };
            }
            if (!tmpHeaders || library.objIsEmpty(tmpHeaders)) {
                tmpHeaders = [{
                    field: 'NO_RECORDS_TO_DISPLAY',
                    headerText: '',
                    text: ''
                }];
            }
            this.headers = library.cloneObj(tmpHeaders, true, true);
            let tmpAggregates = [];
            if (this.vueGridSettings.grouping) {
                for (let i in tmpHeaders) {
                    if (tmpHeaders[i].field !== 'SEARCH') {
                        let tmpTemplateName = this.cId + "_group_caption__template_" + tmpHeaders[i].field + library.getUniqueID();
                        let template = library.createTemplateComponent(tmpTemplateName,
                            {
                                template: `<div v-html="data.Custom"></div>`,
                                components: {
                                    control: controlComponent
                                },
                                data() {
                                    return {
                                        data: {}
                                    };
                                },
                            }, this);
                        tmpAggregates.push({
                            field: tmpHeaders[i].field,
                            type: 'custom',
                            customAggregateFn: (data) => {
                                let fieldValues = data.items.map((tmp) => tmp[tmpHeaders[i].field]);
                                return fieldValues.every((tmp) => tmp === fieldValues[0]) ? fieldValues[0] : '';
                            },
                            groupCaptionTemplate: template,
                        });
                    }
                }
                // eslint-disable-next-line no-template-curly-in-string
                this.vueGridSettings.groupSettings.captionTemplate = '<div class="group-checkbox"></div>';
            }

            this.aggregates = library.cloneObj(tmpAggregates, true, true);
            this.summary = tmpSummary;
            this.records = tmpRecords;
            this.$nextTick(() => {
                this.preparingData = false;
                this.$emit('update:preparingData', false);
            });
        },
        rowSelected() {
            let tmpSelectedRecords = [];
            let tmpSelectedRecordsFullData = [];
            if (this.$refs && this.$refs[this.ref] && typeof this.$refs[this.ref].getSelectedRecords === 'function') {
                let selectedRecords = this.$refs[this.ref].getSelectedRecords();
                tmpSelectedRecordsFullData = library.cloneObj(selectedRecords);
                for (let i in selectedRecords) {
                    if (i === 'length') continue;
                    tmpSelectedRecords.push(selectedRecords[i].rowID);
                }
                let selectedRowIndexes = this.$refs[this.ref].ej2Instances.getSelectedRowIndexes();
                let checker = (arr, target) => target.every((v) => arr.includes(v));
                let groupSelected = {};
                for (let i in this.recordsByGroups) {
                    if (checker(selectedRowIndexes, this.recordsByGroups[i])) {
                        groupSelected[i] = true;
                    } else {
                        groupSelected[i] = false;
                    }
                }
                this.groupSelected = library.cloneObj(groupSelected);
            }
            this.selectedRecords = tmpSelectedRecords;
            this.selectedRecordsFullData = tmpSelectedRecordsFullData;
            this.disableMenuLeftControls();
            this.$emit('update:propSelectedRecords', tmpSelectedRecords);
            this.$emit('update:propSelectedRecordsFullData', tmpSelectedRecordsFullData);
        },
        resizeToContent() {
            // eslint-disable-next-line camelcase
            if (typeof profile_getFormObject === 'function') {
                let theForm = profile_getFormObject();
                if (theForm && theForm.recordID) {
                    // eslint-disable-next-line camelcase
                    if (typeof SmartTabs === 'object' && typeof general_resizeToContent === 'function') {
                        general_resizeToContent(1, 0, 5);
                    }
                }
            }
        },
        contextMenuOpen(args) {
            if (args.rowInfo && args.rowInfo.target && args.rowInfo.target.classList && (args.rowInfo.target.classList.contains('e-headercelldiv') || args.rowInfo.target.classList.contains('e-content'))) {
                args.cancel = true;
            }
            if (typeof this.$refs?.[this.ref]?.ej2Instances?.contextMenuModule?.contextMenu?.hideItems === 'function') {
                let hideItems = [];
                let showItems = [];
                for (let i in this.customCtxMenu) {
                    if (this.isMenuItemDisabled(this.customCtxMenu[i].action)) {
                        hideItems.push(this.customCtxMenu[i].action);
                    } else {
                        showItems.push(this.customCtxMenu[i].action);
                    }
                }
                if (hideItems.length) {
                    this.$refs[this.ref].ej2Instances.contextMenuModule.contextMenu.hideItems(hideItems, true);
                }
                if (showItems.length) {
                    this.$refs[this.ref].ej2Instances.contextMenuModule.contextMenu.showItems(showItems, true);
                }
            }
        },
        contextMenuClick(args) {
            if (args && args.rowInfo && args.rowInfo.rowData && args.rowInfo.rowData.rowID) {
                let act = args.item.id.toLowerCase();
                let isCustom = args.item.isCustom || false;
                let recordId = args.rowInfo.rowData.rowID;
                if (!isCustom) {
                    let params = {
                        recordId: recordId
                    };
                    if (act === 'clipboard') params.text = args.rowInfo.target.innerText;
                    this.doAction(act, params);
                } else {
                    let forceRecordId = {};
                    let selectedPsp = this.controls[act.toUpperCase()]?.additionalData?.needSelectedPsp || 'aff';
                    if (typeof args?.rowInfo?.rowData?.rowID !== 'undefined') {
                        forceRecordId[selectedPsp + 'ID'] = args.rowInfo.rowData[selectedPsp + 'ID'];
                    }
                    if (!this.controls[act.toUpperCase()]) return;
                    this.doAction('edit', { forceRecordId: forceRecordId, additionalData: this.controls[act.toUpperCase()].additionalData });
                }
            }
        },
        recordDoubleClick(args) {
            let editIsDisabled = false;
            let abbrev = configStore.pspParentNamesAbbrev[this.psp];
            if (abbrev) {
                editIsDisabled = this.isMenuItemDisabled(abbrev.toUpperCase() + 'GRID_EDIT', false, true);
            }
            if (args?.rowData?.rowID && !editIsDisabled) {
                let recordId = args.rowData.rowID;
                this.doAction('edit', { forceRecordId: { affID: recordId } });
            } else if (
                typeof args?.rowData === 'object'
                && typeof this.controls['CLIENT_GRID_DETAILS_BY__' + this.psp] !== 'undefined'
                && typeof this.controls['CLIENT_GRID_DETAILS_BY__' + this.psp]?.value !== 'undefined'
                && this.controls['CLIENT_GRID_DETAILS_BY__' + this.psp]?.value
            ) {
                let recordID = null;
                let recordPsp = null;
                switch (this.controls['CLIENT_GRID_DETAILS_BY__' + this.psp].value) {
                    case 'AFF_VOL':
                        recordPsp = configStore.pspParentNamesAbbrev[1];
                        recordID = args?.rowData?.volID;
                        editIsDisabled = this.isMenuItemDisabled(abbrev.toUpperCase() + 'GRID_VOLUNTEER_EDIT', false, true);
                        break;
                    case 'AFF_ORG':
                        recordPsp = configStore.pspParentNamesAbbrev[3];
                        recordID = args?.rowData?.orgID;
                        editIsDisabled = this.isMenuItemDisabled(abbrev.toUpperCase() + 'GRID_ORGANIZATION_EDIT', false, true);
                        break;
                    case 'AFF_AE':
                        recordPsp = configStore.pspParentNamesAbbrev[8];
                        recordID = args?.rowData?.aeID;
                        editIsDisabled = this.isMenuItemDisabled(abbrev.toUpperCase() + 'GRID_ACTIVITY_EDIT', false, true);
                        break;
                }
                if (!editIsDisabled && recordPsp && recordID) {
                    actionStore.openProfile({ recordPsp: recordPsp, recordId: recordID });
                }
            }
        },
        async delete() {
            let response = await actionStore.deleteRecord({
                recordPsp: this.psp,
                recordId: this.selectedRecords
            });
            if (response.status === 'success') this.reloadGrid(['records']);
        },
        async edit(selectedRecordsFullData, button) {
            let recordPsp = button?.additionalData?.needSelectedPsp || 'aff';
            let tmpSelectedRecordsFullData = selectedRecordsFullData && selectedRecordsFullData.rowID ? [selectedRecordsFullData] : this.selectedRecordsFullData;
            if (tmpSelectedRecordsFullData && tmpSelectedRecordsFullData.length) {
                if (recordPsp === 'aff') {
                    if (tmpSelectedRecordsFullData.length !== 1) {
                        let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                        let msg = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_EMPTY_3', 'affiliation');
                        library.showDialog(msg, false, false, { title: title, showAsAlert: true });
                        return;
                    }
                    let response = await actionStore.editAffiliation({ affID: tmpSelectedRecordsFullData[0].rowID });
                    if (response && response.status !== 'failure') {
                        this.reloadGrid(['records']);
                    }
                } else {
                    let recordID = tmpSelectedRecordsFullData[0][recordPsp + 'ID'];
                    if (recordPsp && parseInt(recordID, 10) > 0) {
                        await actionStore.openProfile({ recordPsp: recordPsp, recordId: recordID });
                    }
                }
            }
        },
        async processAction(act) {
            switch (act) {
                case 'trapEnter':
                    this.$nextTick(() => {
                        this.setGridSettings(false, false, { isSearch: true });
                    });
                    break;
            }
        },
        actionBegin(event) {
            switch (event.requestType) {
                case 'sorting':
                    if (event?.target?.classList?.contains('e-sortnumber')) {
                        event.cancel = true;
                        if (!this.selectedGridMode) this.doAction('customizeSort', {});
                    } else {
                        this.$nextTick(() => {
                            this.setGridSettings(false, false, { isSorting: true, columnName: event?.columnName });
                        });
                    }
                    break;
                case 'grouping':
                    this.$nextTick(() => {
                        this.setGridSettings(false, false, { isGrouping: true, columnName: event?.columnName });
                    });
                    break;
                case 'ungrouping':
                    this.$nextTick(() => {
                        this.setGridSettings(false, false, { isUngrouping: true, columnName: event?.columnName });
                    });
                    break;
            }
        },
        async reloadGrid(featuresToReload) {
            if (!this.psp) return;
            this.groupingColumns = {};
            library.showLoadingIndicator(this.cId + '_wrapper');
            let gridInfo = ['gridControls', 'grids', 'filters', 'menuContext', 'menuLeft'];
            let gridData = ['gridSettings', 'records'];
            let defaultFeaturesToReturn = [...gridInfo, ...gridData];
            let featuresToReturn = Array.isArray(featuresToReload) ? featuresToReload : defaultFeaturesToReturn;
            defaultFeaturesToReturn.forEach((tmpFeature) => {
                if (tmpFeature !== 'menuContext' && library.objIsEmpty(this[tmpFeature]) && featuresToReturn.indexOf(tmpFeature) === -1) featuresToReturn.push(tmpFeature);
            });
            if (library.arrayIncludesAny(featuresToReturn, gridInfo)) {
                let sDsParams = {
                    sDsParams: {
                        force: true
                    }
                };
                let mainGridDataReq = await this.sDs.post('ec_getMainGridInfo', this.psp, featuresToReturn, sDsParams);
                if (mainGridDataReq && mainGridDataReq.status === 'success' && mainGridDataReq.data) {
                    this.prepareGridInfo(mainGridDataReq.data);
                }
            }
            await this.getGridSettings(featuresToReturn.indexOf('gridSettings') !== -1);
            if (featuresToReturn.indexOf('records') !== -1) {
                this.records = [];
                await this.getGridRecords();
            }
            this.prepareData();
            this.disableMenuLeftControls();
            this.resizeToContent();
            this.$nextTick(() => {
                this.reloadingData = false;
                this.resizeHeight();
                library.hideLoadingIndicator(this.cId + '_wrapper');
            });
        },
        prepareGridInfo(mainGridInfo) {
            if (mainGridInfo.menuLeft) {
                this.reloadingMenuLeft = true;
                let tmpControls = [];
                for (let i in mainGridInfo.menuLeft) {
                    if (i === 'length') continue;
                    let isDroprownButton = typeof mainGridInfo.menuLeft[i].items !== 'undefined' || mainGridInfo.menuLeft[i].type === 'automation' || mainGridInfo.menuLeft[i].type === 'logbook';
                    if (
                        typeof mainGridInfo.menuLeft[i].needSelectedPsp === 'undefined'
                        && (
                            mainGridInfo.menuLeft[i].needSelected
                            || mainGridInfo.menuLeft[i].needOneSelected
                        )
                    ) {
                        mainGridInfo.menuLeft[i].needSelectedPsp = configStore.pspParentNamesAbbrev[this.psp];
                    }
                    let tmpControl = {
                        name: mainGridInfo.menuLeft[i].name,
                        label: mainGridInfo.menuLeft[i].title,
                        width: '100%',
                        additionalData: library.cloneObj(mainGridInfo.menuLeft[i])
                    };
                    if (isDroprownButton) {
                        tmpControl['type'] = 'dropdownbutton';
                        tmpControl['onselect'] = this.dropdownButtonAction;
                    } else {
                        tmpControl['type'] = 'button';
                        tmpControl['onclick'] = this.doAction;
                    }
                    tmpControls.push(tmpControl);
                }
                tmpControls.forEach((control) => {
                    let controlStoreIndex = createStoreIndex(this.storeId, control.name);
                    controlStore().addControl(control, this, controlStoreIndex);
                });
                this.menuLeft = tmpControls;
                this.reloadingMenuLeft = false;
            }
            if (mainGridInfo.menuContext) {
                let tmpButtons = [];
                for (let i in mainGridInfo.menuContext) {
                    if (i === 'length') continue;
                    tmpButtons.push({
                        text: mainGridInfo.menuContext[i].title,
                        id: mainGridInfo.menuContext[i].action
                    });
                }
                for (let i in this.customCtxMenu) {
                    if (i === 'length') continue;
                    let isCustom = true;
                    if (['clipboard'].indexOf(this.customCtxMenu[i].action) !== -1) isCustom = false;
                    tmpButtons.push({
                        text: this.customCtxMenu[i].title,
                        id: this.customCtxMenu[i].action,
                        isCustom: isCustom
                    });
                }
                this.$nextTick(() => {
                    this.ctxMenu = tmpButtons;
                });
            }
            if (mainGridInfo.grids) {
                this.reloadGrids = true;
                let tmpGrids = [];
                let selectedGrid = null;
                for (let i in mainGridInfo.grids) {
                    if (i === 'length') continue;
                    if (mainGridInfo.grids[i].selected) {
                        selectedGrid = mainGridInfo.grids[i].CLIENT_GRID_SAVED_ID;
                    }
                    tmpGrids.push({
                        text: mainGridInfo.grids[i].CLIENT_GRID_SAVED_NAME,
                        value: mainGridInfo.grids[i].CLIENT_GRID_SAVED_ID
                    });
                }
                if (selectedGrid && selectedGrid !== this.selectedGrid) {
                    this.selectedGrid = selectedGrid;
                }
                if (!selectedGrid && this.selectedGrid) {
                    this.selectedGrid = null;
                }
                if (!library.isEqualObj(this.grids, tmpGrids)) {
                    this.grids = tmpGrids;
                }
                this.reloadGrids = false;
            }
            if (mainGridInfo.filters) {
                this.reloadFilters = true;
                let tmpFilters = [];
                let selectedFilter = null;
                for (let i in mainGridInfo.filters) {
                    if (i === 'length') continue;
                    if (mainGridInfo.filters[i].selected) {
                        selectedFilter = mainGridInfo.filters[i].FILTER_ID;
                    }
                    tmpFilters.push({
                        text: mainGridInfo.filters[i].FILTER_TITLE,
                        value: mainGridInfo.filters[i].FILTER_ID
                    });
                }
                if (selectedFilter && selectedFilter !== this.selectedFilter) {
                    this.selectedFilter = selectedFilter;
                }
                if (!selectedFilter && this.selectedFilter) {
                    this.selectedFilter = null;
                }
                if (!library.isEqualObj(this.filters, tmpFilters)) {
                    this.filters = tmpFilters;
                }
                this.reloadFilters = false;
            }
            if (mainGridInfo.gridControls) {
                this.reloadGridControls = true;
                let tmpGridControls = {};
                for (let i in mainGridInfo.gridControls) {
                    if (i === 'length') continue;
                    tmpGridControls[mainGridInfo.gridControls[i].name] = mainGridInfo.gridControls[i].title || ' ';
                }
                if (!library.isEqualObj(this.gridControls, tmpGridControls)) {
                    this.gridControls = tmpGridControls;
                }
                this.reloadGridControls = false;
            }
        },
        dropdownButtonAction(event, button) {
            let act;
            let recordPsp = button?.additionalData?.needSelectedPsp || 'aff';
            let records = this.selectedByPsp[recordPsp] || [];
            if (event && event?.item?.additionalData?.action) {
                act = event.item.additionalData.action;
            }
            let params = {};
            params.psp = configStore?.pspIds?.[recordPsp] || 32;
            if (act === 'logbook_grid') params.psp = 32;
            params.isMainGrid = true;
            params.actVal = act;
            params.recordId = records;
            if (act) {
                actionStore.actions.iframeProcessSubmit(act, params, params.width, params.height);
            }
        },
        async getGridSettings(refresh) {
            if (refresh || library.objIsEmpty(this.gridSettings)) {
                let sDsParams = {
                    sDsParams: {
                        force: true
                    }
                };
                let gridSettingsReq = await this.sDs.post('ec_getGridSettings', this.psp, this.selectedGrid, sDsParams);
                if (gridSettingsReq && gridSettingsReq?.status === 'success' && gridSettingsReq?.data) {
                    this.gridSettings = library.cloneObj(gridSettingsReq.data);
                }
            }
            if (!library.objIsEmpty(this.gridSettings)) {
                if (typeof this.gridSettings['CLIENT_GRID_SAVED_ID'] === 'undefined') this.gridSettings['CLIENT_GRID_SAVED_ID'] = null;
                this.selectedGridType = parseInt(this.gridSettings.CLIENT_GRID_AFF_TYPE, 10);
                this.selectedGridMode = this.gridSettings?.CLIENT_GRID_DETAILS_BY || null;
                this.pageSize = this.gridSettings?.CLIENT_GRID_SIZE || 100;
                this.vueGridSettings.grouping = this.gridSettings.CLIENT_GRID_MODE !== 0;
                if (this.gridSettings?.columns) {
                    let tmpGridHeaders = [];
                    for (let i in this.gridSettings.columns) {
                        if (i === 'length') continue;
                        let width = this.gridSettings.columns[i].CLIENT_GRID_WIDTH ? this.gridSettings.columns[i].CLIENT_GRID_WIDTH : this.gridSettings.columns[i].DEFAULT_WIDTH;
                        let gridHeader = library.cloneObj(this.gridSettings.columns[i]);
                        gridHeader.field = this.gridSettings.columns[i].GRID_FIELD_NAME;
                        gridHeader.text = this.gridSettings.columns[i].drawTitle;
                        gridHeader.width = width;
                        gridHeader.headerText = this.gridSettings.columns[i].drawTitle;
                        gridHeader.type = this.gridSettings.columns[i].TYPE;
                        gridHeader.placeholder = this.gridSettings.columns[i].searchPlaceholder || '';
                        gridHeader.CLIENT_GRID_SEARCH_OPTION = this.gridSettings.columns[i].CLIENT_GRID_SEARCH_OPTION + '';
                        if (this.gridSettings.columns[i].items) {
                            let tmpItems = [];
                            for (let j in this.gridSettings.columns[i].items) {
                                if (j === 'length') continue;
                                tmpItems.push({
                                    text: this.gridSettings.columns[i].items[j].title,
                                    value: this.gridSettings.columns[i].items[j].id + '',
                                });
                            }
                            gridHeader.items = tmpItems;
                        }
                        if (this.gridSettings.columns[i].TYPE === 13 || this.gridSettings.columns[i].TYPE === 214) {
                            gridHeader['columnTemplate'] = '<div v-html="data[\'' + this.gridSettings.columns[i].GRID_FIELD_NAME + '\']"></div>';
                        }
                        gridHeader['filterTemplate'] = true;
                        tmpGridHeaders.push(gridHeader);
                    }
                    this.data.headers = tmpGridHeaders;
                }
            }
        },
        async setGridSettings(ev, button, options) {
            if (typeof ev?.isInteracted !== 'undefined' && !ev.isInteracted) return;
            this.reloadingData = true;
            let params = {};
            let featuresToReload = [];
            let tmpGridSettings = library.cloneObj(this.gridSettings);
            let clearCurrentPage = false;
            let clearDropdowns = false;
            let clearGridSaveId = true;
            let gridChanged = false;
            let tmpSelectedGrid = this.selectedGrid === false || this.selectedGrid === null ? false : this.selectedGrid;
            let tmpSelectedSavedGrid = this.gridSettings.CLIENT_GRID_SAVED_ID === false || this.gridSettings.CLIENT_GRID_SAVED_ID === null ? false : this.gridSettings.CLIENT_GRID_SAVED_ID;
            if (!library.isEqualObj(parseInt(tmpSelectedGrid, 10), parseInt(tmpSelectedSavedGrid, 10))) {
                params['CLIENT_GRID_SAVED_ID'] = this.selectedGrid;
                tmpGridSettings.CLIENT_GRID_SAVED_ID = parseInt(params['CLIENT_GRID_SAVED_ID'], 10);
                featuresToReload = [...featuresToReload, ...['gridSettings', 'records', 'filters']];
                clearCurrentPage = true;
                gridChanged = true;
            }
            let tmpSelectedFilter = this.selectedFilter === false || this.selectedFilter === null ? false : this.selectedFilter;
            let tmpSelectedGridFilter = this.gridSettings.FILTER_ID === false || this.gridSettings.FILTER_ID === null || this.gridSettings.FILTER_ID === -1 ? false : this.gridSettings.FILTER_ID;
            if (!gridChanged && !library.isEqualObj(parseInt(tmpSelectedFilter, 10), parseInt(tmpSelectedGridFilter, 10))) {
                params['FILTER_ID'] = this.selectedFilter || -1;
                tmpGridSettings.FILTER_ID = parseInt(params['FILTER_ID'], 10);
                let tmpFeaturesToReload = ['gridSettings', 'records'];
                if (options && options?.fromFilterPopup) tmpFeaturesToReload.push('filters');
                if (button?.name?.indexOf?.('GRID_FILTERS_LIST') !== -1) tmpFeaturesToReload.push('filters');
                featuresToReload = [...featuresToReload, ...tmpFeaturesToReload];
                clearCurrentPage = true;
            } else if (gridChanged) {
                this.selectedFilter = null;
                delete params['FILTER_ID'];
            }
            let tmpSelectedType = this.selectedGridType === false || this.selectedGridType === null ? false : this.selectedGridType;
            let tmpSelectedGridType = this.gridSettings.CLIENT_GRID_AFF_TYPE === false || this.gridSettings.CLIENT_GRID_AFF_TYPE === null ? false : this.gridSettings.CLIENT_GRID_AFF_TYPE;
            if (!library.isEqualObj(parseInt(tmpSelectedType, 10), parseInt(tmpSelectedGridType, 10))) {
                params['CLIENT_GRID_AFF_TYPE'] = this.selectedGridType;
                tmpGridSettings.CLIENT_GRID_AFF_TYPE = parseInt(params['CLIENT_GRID_AFF_TYPE'], 10);
                featuresToReload = [...featuresToReload, ...['gridSettings', 'records']];
                clearCurrentPage = true;
            }
            featuresToReload = library.uniqueArray(featuresToReload);

            if (!library.isEqualObj(this.selectedGridMode, this.gridSettings.CLIENT_GRID_DETAILS_BY)) {
                if (this.selectedGridMode || (!this.selectedGridMode && !tmpGridSettings.CLIENT_GRID_MODE)) {
                    if (this.selectedGridMode) {
                        params['CLIENT_GRID_DETAILS_BY'] = this.selectedGridMode;
                        params['CLIENT_GRID_MODE'] = 0;
                        this.vueGridSettings.grouping = false;
                        tmpGridSettings.CLIENT_GRID_DETAILS_BY = params['CLIENT_GRID_DETAILS_BY'];
                        tmpGridSettings.CLIENT_GRID_MODE = params['CLIENT_GRID_MODE'];
                    } else {
                        params['CLIENT_GRID_DETAILS_BY'] = null;
                        params['CLIENT_GRID_MODE'] = 1;
                        this.vueGridSettings.grouping = true;
                        tmpGridSettings.CLIENT_GRID_DETAILS_BY = params['CLIENT_GRID_DETAILS_BY'];
                        tmpGridSettings.CLIENT_GRID_MODE = params['CLIENT_GRID_MODE'];
                    }
                    clearCurrentPage = true;
                    featuresToReload = ['gridSettings', 'records'];
                }
            }

            let tmpGridColumns = this.$refs?.[this.ref]?.getColumns?.() || [];
            if (!tmpGridColumns.length) return;
            let columnSizeChange = false;
            let columnRemove = false;
            let columnReorder = false;
            let columnSearch = false;
            let columnSort = false;
            let columnGroup = false;
            if (options && options?.isRemove && options?.columnName) {
                let removedColumnIndex = tmpGridSettings.columns.findIndex((tmp) => tmp.GRID_FIELD_NAME === options.columnName);
                if (removedColumnIndex >= 0) {
                    tmpGridSettings.columns.splice(removedColumnIndex, 1);
                    columnRemove = true;
                }
            }
            if (options && options?.isSorting && options?.columnName) {
                if (this.sortingColumns.indexOf(options?.columnName) === -1) {
                    // clear sort positions if column is not sorting yet
                    tmpGridSettings.columns.forEach((tmpColumn) => {
                        tmpColumn.CLIENT_GRID_SORT_POS = tmpColumn.GRID_FIELD_NAME === options?.columnName ? 1 : 0;
                    });
                    columnSort = true;
                }
            }
            if (options && options?.showAll) {
                clearGridSaveId = true;
                clearCurrentPage = true;
                clearDropdowns = true;
            }
            // detect column changes
            for (let i in tmpGridSettings.columns) {
                let columnName = tmpGridSettings.columns[i].GRID_FIELD_NAME;
                if (options && options?.columnName && options?.columnName !== columnName) continue; // do not check others if columnName is passed
                let tmpGridColumnsIndex = tmpGridColumns.findIndex((tmp) => tmp.field === columnName);
                if (tmpGridColumnsIndex >= 0) {
                    // check reordering
                    if (options?.isReorder && options?.columnName && (parseInt(i, 10) + 1) !== parseInt(tmpGridColumnsIndex, 10)) columnReorder = true;
                    // check width change
                    if (options?.isResize && options?.columnName && Math.abs(parseInt(tmpGridSettings.columns[i].CLIENT_GRID_WIDTH, 10) - parseInt(tmpGridColumns[tmpGridColumnsIndex].width, 10)) > 15) {
                        tmpGridSettings.columns[i].CLIENT_GRID_WIDTH = parseInt(tmpGridColumns[tmpGridColumnsIndex].width, 10);
                        columnSizeChange = true;
                    }
                    // check sort change
                    if (options?.isSorting && options?.columnName) {
                        if (parseInt(tmpGridSettings.columns[i].CLIENT_GRID_SORT_DIR, 10) !== parseInt(tmpGridColumns[tmpGridColumnsIndex].sortDirection === 'Ascending' ? 0 : 1, 10)) {
                            tmpGridSettings.columns[i].CLIENT_GRID_SORT_DIR = tmpGridColumns[tmpGridColumnsIndex].sortDirection === 'Ascending' ? 0 : 1;
                            columnSort = true;
                        }
                    }
                    // check group change
                    if (options?.isGrouping && options?.columnName) {
                        tmpGridSettings.columns[i].CLIENT_GRID_SORT_GROUP_BY = 1;
                        columnGroup = true;
                    }
                    if (options?.isUngrouping && options?.columnName) {
                        tmpGridSettings.columns[i].CLIENT_GRID_SORT_GROUP_BY = 0;
                        columnGroup = true;
                    }
                    // check search change
                    if (options?.isSearch) {
                        let filter = library.cloneObj(this.filterValue);
                        if (filter[columnName]) {
                            if (options?.clearSearch) {
                                if (this.controls && this.controls[columnName] && this.controls[columnName].type !== 'dropdown') this.controls[columnName].value = '';
                                if (this.controls && this.controls[columnName] && this.controls[columnName].type === 'dropdown') this.controls[columnName].value = null;
                                if (this.controls && this.controls[columnName + '_numberDD']) this.controls[columnName].value = null;
                                if (this.controls && this.controls[columnName + '_numberSecond']) this.controls[columnName].value = '';
                                if (this.controls && this.controls[columnName + '_dateDD']) this.controls[columnName].value = null;
                                if (this.controls && this.controls[columnName + '_dateSecond']) this.controls[columnName].value = '';
                                if (this.controls && this.controls[columnName + '_stringEmptyDD']) this.controls[columnName].value = '';
                                if (this.controls && this.controls[columnName]) this.controls[columnName].value = '';
                                filter[columnName].CLIENT_GRID_SEARCH = "";
                                filter[columnName].CLIENT_GRID_SEARCH_1 = "";
                                filter[columnName].CLIENT_GRID_SEARCH_OPTION = "";
                            }
                            if (tmpGridSettings.columns[i].CLIENT_GRID_SEARCH === null) tmpGridSettings.columns[i].CLIENT_GRID_SEARCH = '';
                            if (tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_1 === null) tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_1 = '';
                            if (tmpGridSettings.columns[i].CLIENT_GRID_SEARCH !== filter[columnName].CLIENT_GRID_SEARCH) {
                                tmpGridSettings.columns[i].CLIENT_GRID_SEARCH = filter[columnName].CLIENT_GRID_SEARCH;
                                columnSearch = true;
                            }
                            if (tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_1 !== filter[columnName].CLIENT_GRID_SEARCH_1) {
                                tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_1 = filter[columnName].CLIENT_GRID_SEARCH_1;
                                columnSearch = true;
                            }
                            let checkSearchValue = true;
                            let isDate = [5, 6, 9, 11, 203].indexOf(tmpGridSettings.columns[i].TYPE) !== -1;
                            if (isDate && parseInt(filter[columnName].CLIENT_GRID_SEARCH_OPTION, 10) > 100) {
                                checkSearchValue = false;
                            }
                            if (
                                typeof tmpGridSettings.columns[i].isShowEmptyDropdown === 'boolean'
                                && tmpGridSettings.columns[i].isShowEmptyDropdown
                            ) {
                                columnSearch = true;
                            } else if (!tmpGridSettings.columns[i].CLIENT_GRID_SEARCH && !tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_1 && checkSearchValue) {
                                tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_OPTION = 0;
                                filter[columnName].CLIENT_GRID_SEARCH_OPTION = 0;
                            }
                            if (parseInt(tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_OPTION, 10) !== parseInt(filter[columnName].CLIENT_GRID_SEARCH_OPTION, 10)) {
                                tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_OPTION = parseInt(filter[columnName].CLIENT_GRID_SEARCH_OPTION, 10);
                                columnSearch = true;
                            }
                            if (
                                tmpGridSettings.columns[i].TYPE === 13
                                && (
                                    !tmpGridSettings.columns[i]?.items?.length
                                    // eslint-disable-next-line eqeqeq
                                    || tmpGridSettings.columns[i].items.findIndex((tmp) => tmp.id == tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_OPTION) === -1
                                )
                            ) {
                                tmpGridSettings.columns[i].CLIENT_GRID_SEARCH_OPTION = 0;
                            }
                        }
                    }
                }
            }
            if (options?.isSearch) {
                if (!columnSearch) clearGridSaveId = false; // actually search is not changed
                // columnSearch = true; // always set gridSettings on search
            }
            let columnsChanged = columnSizeChange || columnRemove || columnReorder || columnSearch || columnSort || columnGroup;
            if (columnSizeChange) {
                clearGridSaveId = false;
                params.CLIENT_GRID_SAVED_ID = tmpGridSettings.CLIENT_GRID_SAVED_ID;
                params.CLIENT_GRID_SAVED_NAME = tmpGridSettings.CLIENT_GRID_SAVED_NAME;
            }
            if (columnsChanged) {
                let newColumns = [];
                for (let i in tmpGridColumns) {
                    let columnName = tmpGridColumns[i].field;
                    if (columnName === 'SEARCH') continue;
                    let tmpGridSettingsColumn = tmpGridSettings.columns.find((tmp) => tmp.GRID_FIELD_NAME === columnName);
                    if (tmpGridSettingsColumn) {
                        newColumns.push(tmpGridSettingsColumn);
                    }
                }
                if (newColumns.length) {
                    // recheck sort position
                    let columnsPositions = [];
                    newColumns.forEach((tmpColumn) => {
                        if (parseInt(tmpColumn.CLIENT_GRID_SORT_POS, 10) > 0) {
                            columnsPositions.push(tmpColumn.CLIENT_GRID_SORT_POS);
                        }
                    });
                    columnsPositions.sort();
                    for (let i in newColumns) {
                        let currentPos = parseInt(newColumns[i].CLIENT_GRID_SORT_POS, 10);
                        if (currentPos > 0) {
                            newColumns[i].CLIENT_GRID_SORT_POS = columnsPositions.indexOf(currentPos) + 1;
                        }
                        if ((newColumns[i].CLIENT_GRID_SORT_GROUP_BY || newColumns[i].CLIENT_GRID_SORT_DIR) && !currentPos && currentPos !== 0) {
                            // if sort is set with no position
                            columnsPositions.push(Math.max(...columnsPositions) + 1);
                            newColumns[i].CLIENT_GRID_SORT_POS = columnsPositions.length;
                        }
                        if (newColumns[i].CLIENT_GRID_SORT_POS > 0 && !newColumns[i].CLIENT_GRID_SORT_DIR) {
                            newColumns[i].CLIENT_GRID_SORT_DIR = 0;
                        }
                    }
                    let columnsWithGroup = newColumns.filter((tmp) => tmp.CLIENT_GRID_SORT_GROUP_BY);
                    if (columnsWithGroup.length) {
                        let currSortPos = 1;
                        let curSortPosForNonGrouped = columnsWithGroup.length ? columnsWithGroup.length + 1 : 1;
                        newColumns.forEach((tmpColumn) => {
                            if (tmpColumn.CLIENT_GRID_SORT_GROUP_BY) {
                                tmpColumn.CLIENT_GRID_SORT_POS = currSortPos;
                                currSortPos++;
                            } else if (parseInt(tmpColumn.CLIENT_GRID_SORT_POS, 10) > 0) {
                                tmpColumn.CLIENT_GRID_SORT_POS = curSortPosForNonGrouped;
                                curSortPosForNonGrouped++;
                            }
                        });
                    }
                    tmpGridSettings.columns = library.cloneObj(newColumns);
                    params.columns = library.cloneObj(newColumns);
                }
            }
            if (library.isEqualObj(this.gridSettings, tmpGridSettings) && !options?.isSearch) return;
            if (columnGroup || columnSort || columnSearch) {
                library.showLoadingIndicator(this.cId + '_wrapper');
                featuresToReload = ['records'];
            }
            if (clearCurrentPage) this.currentPage = 1;
            if (clearGridSaveId && this.selectedGrid && !params.CLIENT_GRID_SAVED_ID) {
                let sDsParams = {
                    sDsParams: {
                        force: true
                    }
                };
                await this.sDs.post('ec_setGridSettings', this.psp, { 'CLIENT_GRID_SAVED_ID': null }, sDsParams);
                this.selectedGrid = null;
                this.selectedFilter = null;
                this.selectedGridType = -1;
                this.selectedGridMode = null;
                delete tmpGridSettings.CLIENT_GRID_SAVED_ID;
                delete tmpGridSettings.CLIENT_GRID_SAVED_NAME;
                params = library.cloneObj(tmpGridSettings);
            }
            if (clearDropdowns) {
                this.selectedGrid = null;
                this.selectedFilter = null;
                this.selectedGridType = -1;
                this.selectedGridMode = null;

                delete tmpGridSettings.CLIENT_GRID_SAVED_ID;
                delete tmpGridSettings.CLIENT_GRID_SAVED_NAME;
                tmpGridSettings.CLIENT_GRID_AFF_TYPE = -1;
                tmpGridSettings.FILTER_ID = null;
                tmpGridSettings.CLIENT_GRID_MODE = 1;
                tmpGridSettings.CLIENT_GRID_DETAILS_BY = null;
                if (typeof this.controls['CLIENT_GRID_DETAILS_BY__' + this.psp] !== 'undefined') {
                    this.controls['CLIENT_GRID_DETAILS_BY__' + this.psp].value = null;
                }
                params = library.cloneObj(tmpGridSettings);
                if (params['FILTER_ID'] === null) params['FILTER_ID'] = -1;
            }
            this.gridSettings = library.cloneObj(tmpGridSettings);

            if (!library.objIsEmpty(params)) {
                let sDsParams = {
                    sDsParams: {
                        force: true
                    }
                };
                await this.sDs.post('ec_setGridSettings', this.psp, params, sDsParams);
                if (featuresToReload.length || columnRemove) {
                    this.$nextTick(() => {
                        this.reloadGrid(featuresToReload);
                    });
                } else {
                    library.hideLoadingIndicator(this.cId + '_wrapper');
                }
            } else {
                library.hideLoadingIndicator(this.cId + '_wrapper');
            }
        },
        async getGridRecords(refresh) {
            this.prevSelectedRecords = library.cloneObj(this.selectedRecords);
            if (refresh) {
                this.records = [];
                this.currentPage = 1;
                this.$emit('update:propSelectedRecords', []);
            }
            let params = {
                'offset': (this.currentPage - 1) * this.pageSize,
                'rowCount': this.pageSize,
                'returnRowCount': true,
                'forceHtml': true,
                'includeObjIDs': true
            };
            let sDsParams = {
                sDsParams: {
                    force: true
                }
            };
            let result = await this.sDs.post('ec_getCurrentGrid', this.psp, params, sDsParams);
            if (result && result.status === 'success') {
                this.totalRecordsCount = result?.data?.rowCount || 0;
                this.totalPages = Math.ceil(this.totalRecordsCount / this.pageSize);
                this.hidePager = !result?.data?.rowCount || (result?.data?.rowCount && result.data.rowCount < this.pageSize);
                this.rowCountAdditional = result?.data?.rowCountAdditional || {};
                this.data.records = library.cloneObj(result.data.records || []);
                this.data.summary = library.cloneObj(result.data.summary || []);
                if (result?.data?.objIDsCount) {
                    let entitiesSummary = [];
                    let summaryOrder = {
                        'VOLUNTEER_ID': 'ENTITY_VOLUNTEER',
                        'ORGANIZATION_ID': 'ENTITY_ORGANIZATION',
                        'ACTIVITY_ENTITY_ID': 'ENTITY_ACTIVITY_ENTITY',
                        'AFF_STATUS_ID': 'Aff Status'
                    };
                    for (let i in summaryOrder) {
                        if (typeof result.data.objIDsCount[i] !== 'undefined') {
                            let isMulti = result.data.objIDsCount[i] > 1;
                            // eslint-disable-next-line no-await-in-loop
                            let entityPlural = i === 'AFF_STATUS_ID' ? summaryOrder[i] + (isMulti ? 'es' : '') : await ddStore.getAlias('COMMON', summaryOrder[i] + (isMulti ? '_PLURAL' : ''));
                            if (entityPlural) {
                                entityPlural = library.capitalizeFirstLetter(entityPlural);
                                entitiesSummary.push(result.data.objIDsCount[i] + ' ' + entityPlural);
                            }
                        }
                    }
                    if (entitiesSummary.length) {
                        this.entitiesSummary = library.cloneObj(entitiesSummary.join(', '));
                    }
                }
            }
        },
        async doAction(act, params) {
            if (!params) params = {};
            let currentAct = params?.additionalData?.type || act;
            let actionParams = {};
            actionParams.openInSameWindow = true;
            actionParams.psp = this.psp;
            actionParams.isMainGrid = true;
            actionParams.actVal = currentAct;
            actionParams.doLocalAction = this.doLocalAction;
            actionParams.needResponse = true;
            if (currentAct) {
                let recordPsp = params?.additionalData?.needSelectedPsp || 'aff';
                switch (currentAct) {
                    case 'refresh':
                        if (typeof doAction === 'function') doAction('refresh');
                        break;
                    case 'clipboard':
                        this.clipboardValue = params.text;
                        this.$nextTick(() => {
                            this.$refs['clipboard__' + this.psp].select();
                            document.execCommand("copy");
                        });
                        break;
                    case 'showAll':
                        if (typeof this?.$refs?.[this.ref]?.clearSelection === 'function') this.$refs[this.ref].clearSelection();
                        this.selectedRecords = [];
                        this.$emit('update:propSelectedRecords', []);
                        this.groupingColumns = {};
                        this.$nextTick(() => {
                            this.setGridSettings(false, false, { isSearch: true, clearSearch: true, showAll: true });
                        });
                        break;
                    case 'customizeGrid':
                        actionParams.recordId = this.selectedGrid || -1;
                        actionParams.windowName = 'CustomizeGrid';
                        await actionStore.openCustomizeGrid(actionParams);
                        break;
                    case 'customizeSort':
                        await actionStore.openCustomizeSort(actionParams);
                        break;
                    case 'filter':
                        if (typeof actionParams.dialogSettings === 'undefined') actionParams.dialogSettings = {};
                        actionParams.dialogSettings.cssClass = "show-only-content-popup iframe-popup";
                        actionParams.doLocalAction = this.doLocalAction;
                        actionParams.needResponse = true;
                        await actionStore.actions.iframeProcessSubmit(currentAct, actionParams, actionParams.width, actionParams.height);
                        break;
                    case 'delete':
                        if (this.selectedByPsp['aff'].length) {
                            let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE_THE_TITLE');
                            let message = '';
                            if (this.selectedByPsp['aff'].length === 1) {
                                message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_DELETE', 'affiliation');
                            } else {
                                message = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_MULTIDELETE', 'affiliations');
                            }
                            library.showDialog(message, async (tmpDialog) => {
                                if (tmpDialog && tmpDialog?.dialog?.element?.id) library.showLoadingIndicator(tmpDialog.dialog.element.id);
                                await this.sDs.post('sds_deleteAffiliation', this.selectedByPsp['aff']);
                                if (tmpDialog && tmpDialog?.dialog?.element?.id) library.hideLoadingIndicator(tmpDialog.dialog.element.id);
                                this.reloadGrid(['records']);
                            }, false, { title: title });
                        }
                        break;
                    case 'edit':
                        // eslint-disable-next-line no-case-declarations
                        let tmpSelectedRecordsFullData = params?.forceRecordId ? [params.forceRecordId] : this.selectedRecordsFullData;
                        if (tmpSelectedRecordsFullData && tmpSelectedRecordsFullData.length) {
                            if (recordPsp === 'aff') {
                                if (tmpSelectedRecordsFullData.length !== 1) {
                                    let title = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_TITLE');
                                    let msg = await ddStore.getAlias('COMMON', 'ERRORMESSAGE_EMPTY_3', 'affiliation');
                                    library.showDialog(msg, false, false, { title: title, showAsAlert: true });
                                    return;
                                }
                                let response = await actionStore.editAffiliation({ affID: tmpSelectedRecordsFullData[0].affID });
                                if (response && response.status !== 'failure') {
                                    this.reloadGrid(['records']);
                                }
                            } else {
                                let recordID = tmpSelectedRecordsFullData[0][recordPsp + 'ID'];
                                if (recordPsp && parseInt(recordID, 10) > 0) {
                                    await actionStore.openProfile({ recordPsp: recordPsp, recordId: recordID });
                                }
                            }
                        }
                        break;
                    case 'history':
                        if (this.selectedByPsp['aff'].length) {
                            let payload = {
                                contextRecordId: this.selectedByPsp['aff'][0],
                                component: {}
                            };
                            actionStore.openAffiliationHistory(payload);
                        }
                        break;
                    case 'email':
                        actionStore.openEmail({ psp: 32, recordId: this.selectedByPsp['aff'], allIDs: true });
                        break;
                    case 'automation':
                        await actionStore.openAutomationRun({ psp: 32, recordId: this.selectedByPsp['aff'] });
                        break;
                    case 'report':
                        // eslint-disable-next-line no-case-declarations
                        let act = 'DataGridReport';
                        params.openInSameWindow = true;
                        params.psp = 32;
                        params.isMainGrid = true;
                        params.actVal = act;
                        params.recordId = this.selectedByPsp['aff'];
                        params.hideOpenInNewWindow = true;
                        if (typeof params.dialogSettings === 'undefined') params.dialogSettings = {};
                        params.dialogSettings.cssClass = "show-only-content-popup iframe-popup";
                        params.width = false;
                        params.height = false;
                        await actionStore.actions.iframeProcessSubmit(act, params, params.width, params.height);
                        break;
                    case 'calendar':
                        // eslint-disable-next-line no-case-declarations
                        let tmpCalendarParams = {
                            recordPsp: recordPsp,
                            isMainGrid: true
                        };
                        if (this.selectedByPsp[recordPsp].length) {
                            tmpCalendarParams.recordId = this.selectedByPsp[recordPsp];
                        }
                        await actionStore.openCalendar(tmpCalendarParams);
                        break;
                    case 'place':
                        if (this.selectedByPsp[recordPsp].length) {
                            await actionStore.openPlace({
                                recordPsp: recordPsp,
                                recordId: this.selectedByPsp[recordPsp],
                                isMainGrid: true
                            });
                        }
                        break;
                    case 'addhours':
                        if (this.selectedByPsp[recordPsp].length) {
                            await actionStore.openAddhours({ recordId: this.selectedByPsp[recordPsp] });
                        }
                        break;
                    case 'logbook':
                        if (this.selectedByPsp[recordPsp].length) {
                            await actionStore.openLogBook({
                                psp: 1,
                                recordId: this.selectedByPsp[recordPsp],
                                isMainGrid: true,
                                actVal: 'logbook_selected'
                            });
                        }
                        break;
                    case 'new_logbook_lbe':
                        if (this.selectedByPsp[recordPsp].length) {
                            await actionStore.openLogBookLBE({
                                recordPsp: recordPsp,
                                recordId: this.selectedByPsp[recordPsp],
                                isMainGrid: true
                            });
                        }
                        break;
                    case 'new_logbook_waiver':
                        if (this.selectedByPsp[recordPsp].length) {
                            await actionStore.openLogBookWaiver({
                                recordId: this.selectedByPsp[recordPsp],
                                isMainGrid: true
                            });
                        }
                        break;
                    case 'new_logbook_training':
                        if (this.selectedByPsp[recordPsp].length) {
                            await actionStore.openLogBookTraining({ recordId: this.selectedByPsp[recordPsp], isMainGrid: true });
                        }
                        break;
                }
            }
        },
        async doLocalAction(act, params) {
            let featuresToReload = [];
            switch (act) {
                case 'customizeGrid':
                    if (!(typeof params?.document?.head?.innerHTML !== 'undefined' && params?.document?.head?.innerHTML.indexOf('navigation_reloadMainGrid') === -1)) {
                        featuresToReload = ['gridSettings', 'grids', 'filters', 'records'];
                    }
                    if (params && params?.status === 'failure') {
                        featuresToReload = [];
                    }
                    break;
                case 'customizeSort':
                    if (typeof params?.actionParams === 'string') {
                        featuresToReload = ['gridSettings', 'records'];
                    }
                    break;
                case 'filter':
                    if (typeof params?.actionParams === 'string') {
                        let tmpParams = params.actionParams.split(',');
                        switch (tmpParams[0]) {
                            case "useFilter":
                                // eslint-disable-next-line no-case-declarations
                                let filterId = parseInt(tmpParams[1], 10);
                                if (filterId) {
                                    this.selectedFilter = filterId;
                                    this.setGridSettings(false, false, { fromFilterPopup: true });
                                }
                                break;
                        }
                    }
                    break;
            }
            if (featuresToReload.length) {
                this.reloadGrid(featuresToReload);
            }
        },
        mouseUpListener(e) {
            document.removeEventListener('mouseup', this.mouseUpListener, true);
            setTimeout(async () => {
                if (this.columnRemoved) {
                    let gridInfo = library.cloneObj(this.gridSettings);
                    let tmpColumn = gridInfo.columns.find((elem) => elem.GRID_FIELD_NAME === this.columnRemoved);
                    if (tmpColumn) {
                        if (tmpColumn.MANDATORY) {
                            let title = await ddStore.getAlias('COMMON', 'WARNINGMESSAGE_TITLE');
                            let message = await ddStore.getAlias('DATA_GRID', 'GRIDENGINE_ERR_DETACH_MANDATORY');
                            library.showDialog(message, false, false, { title: title, showAsAlert: true });
                        } else {
                            this.$nextTick(() => {
                                this.setGridSettings(false, false, { isRemove: true, columnName: this.columnRemoved });
                            });
                        }
                    }
                }
            }, 500);
        },
        columnDragStart(args) {
            this.columnRemoved = args.column.field;
            document.removeEventListener('mouseup', this.mouseUpListener, true);
            document.addEventListener('mouseup', this.mouseUpListener, true);
        },
        columnDrop(ev) {
            this.columnRemoved = false;
            if (ev && typeof ev?.target?.classList?.contains === 'function' && ev.target.classList.contains('e-groupdroparea')) return;
            this.$nextTick(() => {
                this.setGridSettings(false, false, { isReorder: true, columnName: ev?.column?.field });
            });
        },
        resizeStart() {
            this.width = 'auto';
        },
        async resizeStop(event) {
            if (event?.column?.field && event.column.field !== 'SEARCH' && event.column.width) {
                let width = (event.column.width + '').replace('px', '');
                let columnName = event.column.field;
                this.$nextTick(async () => {
                    await this.setGridSettings(false, false, { isResize: true, columnName: columnName });
                });
                if (this.gridSettings.SUMMARY_MODE) {
                    for (let i in this.headers) {
                        if (i === 'length') continue;

                        if (this.headers[i] && this.headers[i].field === columnName) {
                            this.headers[i].width = width;
                            break;
                        }
                    }

                    if (document.getElementById('summary_' + columnName)) {
                        document.getElementById('summary_' + columnName).style.width = width + 'px';
                    }

                    if (document.getElementById('avarage_' + columnName)) {
                        document.getElementById('avarage_' + columnName).style.width = width + 'px';
                    }
                }
            }
        },
        goToPage: function (pageIndex) {
            if (typeof pageIndex !== 'number' && parseInt(this.$refs?.['pageInput']?.value, 10) > 1) {
                pageIndex = parseInt(this.$refs['pageInput'].value, 10);
            }
            if (pageIndex !== this.currentPage && pageIndex >= 1 && pageIndex <= this.totalPages) {
                this.currentPage = pageIndex;
                this.reloadGrid(['records']);
            }
        },
        toggleEntitiesSummary() {
            this.showEntitiesSummary = !this.showEntitiesSummary;
            let abbrev = configStore.pspParentNamesAbbrev[this.psp];
            if (abbrev) {
                let sDsParams = {
                    sDsParams: {
                        force: true
                    }
                };
                this.sDs.post('er_setEcUserProperty', abbrev.toUpperCase() + '_showEntitiesSummary', this.showEntitiesSummary, sDsParams);
            }
        }
    },
    components: {
        'ejs-grid': defineAsyncComponent(() => import('@common/syncfusion/grid')),
        'e-columns': ColumnsDirective,
        'e-column': ColumnDirective,
        'e-aggregates': AggregatesDirective,
        'e-aggregate': AggregateDirective,
        'ejs-tooltip': defineAsyncComponent(() => import('@common/syncfusion/tooltip'))
    }
};

componentStore.initComponent(masterGridCmp, masterGridConfig, '@common/grid/grid.vue');
export { masterGridConfig, masterGridCmp };
export default masterGridCmp;
</script>
<style>
.gridHeaderCellTooltip {
    min-width: 150px !important;
}
</style>
<style scoped>
:deep(#gridControls) {
    width: 100%;
    overflow: hidden;
}
:deep(.vms-main-grid-parts) {
    display: flex;
}
:deep(.leftcolumn > *) {
    margin-top: 5px;
    padding-left: 10px;
    padding-right: 10px;
}

:deep(.leftcolumn > .control) {
    width: 135px;
    margin: 0 10px;
    margin-bottom: 5px;
}
:deep(.e-headercell.e-defaultcursor) {
    padding-left: 0px !important;
}
:deep(.master-grid [name^="SEARCH"]) {
    margin-left: -5px;
}
:deep(.master-grid .e-sortnumber) {
    margin-right: 15px;
    color: white;
    font-size: 12px;
    font-weight: 400;
}
:deep(.master-grid .e-sortnumber:hover) {
    text-decoration: underline;
}
:deep(.e-groupcaption), :deep(.e-summarycell) {
    border-right-width: 1px !important;
    border-right-style: dashed !important;
    padding: 0 5px !important;
    font-weight: 400 !important;
}
:deep(.e-grouptopleftcell-group-ungroup-all) {
    padding-left: 0 !important;
}
:deep(.e-grouptopleftcell .e-emptycell) {
    display: none;
}
:deep(.expanded > .group-expand-all) {
    display: none;
}
:deep(.collapsed > .group-collapse-all) {
    display: none;
}
:deep(.leftcolumn .e-btn:disabled) {
    background-color: #a5b3ba !important;
    color: #48565d !important;
}
:deep(.rightcolumn) {
    flex-grow: 12;
    width: 1300px;
    overflow: hidden;
    background-color: white;
}
:deep(.e-tab-header .e-items) {
    float: left !important;
}
:deep(.e-row) {
    background-color: #f9f9f9;
    font-size: 13px;
    font-weight: 400;
}
:deep(.e-row), :deep(.e-rowcell), :deep(.e-columnheader), :deep(.e-filterbar) {
    height: 32px !important;
}
:deep(.e-filterbarcell) {
    padding: 0 3px !important;
}
:deep(.grid-wrapper .e-checkbox-wrapper .e-frame.e-icons) {
    width: 14px;
    height: 14px;
    font-size: 7px;
    line-height: 7px;
}
:deep(.grid-wrapper .e-checkbox-wrapper) {
    width: 14px;
    height: 14px;
    display: block;
}
:deep(.rightcolumn > div) {
    float: left;
}
:deep(.e-row *) {
    font-size: 13px;
    font-weight: 400;
}
:deep(.e-altrow) {
    background-color: #fff;
}
:deep(.e-row:hover) {
    background-color: rgb(254,255,234);
}
:deep(.e-row:hover td) {
    background-color: transparent !important;
}
:deep(.e-columnheader  *) {
    background-color: #607D8B !important;
    color: #fff;
}
:deep(.e-selectionbackground) {
    color: #303030 !important;
    background-color: #e5f7fe !important;
}
:deep(.grid-wrapper) {
    margin: 5px;
    overflow: auto;
}
:deep(.e-columnheader .e-frame) {
    color: #fff !important;
    border-color: #fff !important;
}
:deep(.e-rowcell),
:deep(.e-filterbarcell) {
    border-right: 1px dashed #d6d6d6 !important;
}
:deep(.e-dropdown-btn),
:deep(.e-dropdown-btn.e-btn) {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

:deep(.e-dropdown-btn:hover),
:deep(.e-dropdown-btn.e-btn:hover) {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

:deep(.entities-summary) {
    float: left;
    line-height: 27px;
}
:deep(.entities-summary .entities-summary-toggler) {
    cursor: pointer;
}
:deep(.e-groupsort) {
    display: none !important;
}

:deep(.e-grid .e-gridheader .e-sortfilter .e-headercelldiv),
:deep(.e-grid .e-gridheader .e-stackedheadercelldiv),
:deep(.e-grid .e-gridheader .e-headercell .e-headercelldiv.e-headerchkcelldiv) {
    padding: 0 5px 0 5px;
}

:deep(.e-grid .custom-search-column .e-sortnumber),
:deep(.e-grid .custom-search-column .e-sortfilterdiv) {
    display: none;
}

:deep(.e-grid .e-headercell) {
    padding: 0px 5px;
}

:deep(.e-grid .e-rowcell) {
    padding: 5px 5px;
}

:deep(.e-grid .e-sortfilterdiv) {
    margin: -15px 5px;
}

:deep(.number-filter), :deep(.date-filter), :deep(.string-empty-filter) {
    display: flex;
}

:deep(.number-filter > div),
:deep(.date-filter > div),
:deep(.string-empty-filter > div) {
    flex-grow: 5;
    margin: 0 3px;
}

:deep([id^=grid_mainGrid] .e-filterbarcell:first-child) {
    padding: 0px !important;
}

:deep(.e-checkbox-wrapper .e-frame),
:deep(.e-css.e-checkbox-wrapper .e-frame) {
    width: 14px;
    height: 14px;
    line-height: 7px;
    font-size: 7px;
}

:deep(.e-grid .e-checkbox-wrapper) {
    margin: 0 auto !important;
    width: 28px;
    height: 20px;
    padding: 0 !important;
}

:deep(.vms-affiliation-grid-wrapper .e-grid .e-columnheader .e-checkbox-wrapper) {
    margin-top: 7px !important;
}

:deep(.e-grid .e-headerchkcelldiv) {
    margin: -5px !important;
}

:deep(.e-grid .e-focused:not(.e-menu-item)) {
    box-shadow: unset !important;
}

:deep(.e-grid .e-headercell),
:deep(.e-grid .e-detailheadercell),
:deep(.e-grid .e-rowcell),
:deep(.e-grid .e-headerchkcelldiv) {
    padding: 0 5px !important;
}

:deep(.e-headercell.e-defaultcursor) {
    padding-left: 0px !important;
}

:deep(.e-input-group-icon.e-date-icon),
:deep(*.e-control-wrapper .e-input-group-icon.e-date-icon) {
    margin-bottom: 2px;
}

:deep(.e-ddl.e-popup.e-block.e-lib.e-control.e-popup-open[id*='_masterGrid_']) {
    min-width: 180px;
}

:deep(.master-grid) {
    width: 100%;
    height: 100%;
}

:deep(.master-grid .e-grid),
:deep(.master-grid .e-gridpager),
:deep(.master-grid .e-gridheader) {
    border: none !important;
}

:deep(.master-grid .e-gridpager) {
    min-width: 900px;
}

:deep(.master-grid .e-gridpager > div) {
    display: none;
}

:deep(.master-grid .e-gridpager > div:nth-child(2)) {
    display: block;
}

:deep(.master-grid .grid-navigator.control-section) {
    float: left;
    margin-left: 0px;
    line-height: 27px;
}

:deep(.master-grid .grid-sg-list),
:deep(.master-grid .grid-filter-list) {
    width: 520px;
}

:deep(.master-grid .grid-show-all),
:deep(.master-grid .grid-filters) {
    width: 65px;
}

:deep(.master-grid .grid-settings) {
    width: 90px;
}

:deep(.master-grid .grid-show-all),
:deep(.master-grid .grid-settings),
:deep(.master-grid .grid-sg-list),
:deep(.master-grid .grid-filters),
:deep(.master-grid .grid-filter-list) {
    display: block;
    float: left;
    margin: 5px;
}

:deep(.master-grid .e-row) {
    background-color: #f9f9f9;
    font-size: 13px;
    font-weight: 400;
}

:deep(.master-grid .e-row *) {
    font-size: 13px;
    font-weight: 400;
}

:deep(.master-grid .e-altrow) {
    background-color: #fff;
}

:deep(.master-grid .e-row:hover) {
    background-color: rgb(254,255,234);
}

:deep(.master-grid .e-row:hover td) {
    background-color: transparent !important;
}

:deep(.master-grid .e-columnheader  *) {
    background-color: #607D8B !important;
    color: #fff;
}

:deep(.master-grid .e-selectionbackground) {
    color: #303030 !important;
    background-color: #e5f7fe !important;
}

:deep(.master-grid .grid-wrapper) {
    margin: 0 5px;
    width: 100%;
}
:deep(.master-grid .e-columnheader .e-frame) {
    color: #fff !important;
    border-color: #fff !important;
}

:deep(.master-grid .e-row, .master-grid .e-rowcell) {
    height: 32px !important;
}

:deep(.master-grid .e-rowcell),
:deep(.master-grid .e-filterbarcell) {
    border-right: 1px dashed #d6d6d6 !important;
}
:deep(.master-grid .e-filterbarcell input) {
    height: 18px !important;
}

:deep(.master-grid .e-headercelldiv) {
    text-align: center !important;
}

:deep(.master-grid .rightcolumn button) {
    font-family: "Open Sans","Helvetica Neue",Helvetica,Arial,sans-serif!important;
    background: #e0e0e0!important;
    color: #303030!important;
    border: 1px solid #bdbdbd!important;
    border-radius: 0!important;
    font-weight: 500!important;
    padding: 3px 5px!important;
    text-align: center!important;
    vertical-align: baseline!important;
    width: auto !important;
    height: 26px !important;
    transition: background-color 0.23s ease-in-out 0s !important;
    box-shadow: none !important;
    font-size: 13px !important;
    margin: 0 auto;
}

:deep(.master-grid .e-headertext) {
    font-size: 13px;
    font-weight: 400 !important;
    color: #fff !important;
    text-decoration: none !important;
}

:deep(.master-grid input) {
    line-height: 14px !important;
    font-size: 13px !important;
    min-height: 14px !important;
}

:deep(.master-grid #grid-main-content-inner .e-spinner-pane) {
    background-color: #5a5a5a;
    opacity: 0.25;
}

:deep(.master-grid .e-defaultcursor),
:deep(.master-grid .e-rhandler.e-rcursor) {
    height: 36px !important
}

:deep(.master-grid .master-grid-clipboard){
    width: 1px;
    height: 1px;
    position: absolute;
    top: -1000px;
}

:deep(.master-grid .e-grid .e-filterbarcell),
:deep(.master-grid .e-grid .e-filterbarcelldisabled) {
    padding-left: 5px !important;
    padding-right: 5px !important;
}

:deep(.master-grid .e-sortfilterdiv.e-icons) {
    color: white !important;
}

:deep(.master-grid .e-pagertemplatemessage) {
    float: left;
    line-height: 27px;
    text-align: center;
}
:deep(.master-grid .e-emptyrow) {
    visibility: hidden;
}

:deep(.master-grid .grid-navigator) {
    padding-bottom: 0px;
}

:deep(.master-grid .e-gridpager) {
    display: none;
}

:deep(.e-cloneproperties.e-draganddrop) {
    z-index: 9999999 !important;
    position: fixed !important;
}
:deep(.e-cclist .e-checkbox-wrapper) {
    width: 100%;
}
:deep(.e-cclist .e-checkbox-wrapper > *) {
    display: inline;
}
:deep(.master-grid .grid-type) {
    width: 280px;
    float: left;
    margin-left: 5px;
    padding-left: 0px;
}
:deep(.master-grid .grid-navigator) {
    margin: 0 10px;
}
:deep(.master-grid .grid-details-by) {
    float: left;
    margin-left: 5px;
}
:deep(.master-grid .grid-navigator-pages) {
    margin: 0 5px;
}
:deep(.master-grid .grid-details-by .label-wrapper-inner) {
    margin-top: 3px !important;
}

:deep(.master-grid .grid-details-by .label-wrapper-inner .label-text) {
    font-size: 14px;
    color: #303030;
    font-weight: 600;
    text-decoration: none;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

:deep(.master-grid .e-grid .e-content) {
    overflow-x: hidden !important;
}

:deep(.master-grid .e-input-group-icon.e-date-icon),
:deep(.master-grid *.e-control-wrapper .e-input-group-icon.e-date-icon) {
    margin-bottom: 0px;
}

:deep(.summaryGrid) {
    display: inline-block;
    z-index: 1;
}

:deep(.summaryGrid .infoTitle) {
    margin-top: 10px;
    margin-bottom: 5px;
    font-weight: bold;
}

:deep(.summaryGrid .infoRow) {
    display: inline-block;
    background: #c5d6fc;
    overflow-x: unset;
    padding: 5px 0;
}

:deep(.summaryGrid .infoCol) {
    display: inline-block;
    text-align: right;
    padding-right: 0px;
    margin-left: 0px;
}
:deep(.summaryGrid .infoCol > div) {
    padding-right: 5px;
}
:deep(.e-headercontent),
:deep(.e-gridcontent) {
    border: 1px solid #d6d6d6 !important;
}
</style>
